import React, { useState, useEffect } from "react";
import "./customCart.css";
import lawService from "./customAjax.js";
import { Link, Navigate } from "react-router-dom";
import { BsCaretDown, BsCaretUp } from "react-icons/bs";
import { Collapse, Button, CardBody, Card } from "reactstrap";
import { Blocks } from "react-loader-spinner";
function CustomCart() {
const [agentAttend,setAgentAttend]=useState("Did Agent Attend Initial Consult?")
  const [attorneys, setAttorneys] = useState([
    { id: " ", name: "No Lead Attorney Found" },
  ]);
  const [loading, setLoading] = useState({
    loading: false,
  });
  const [isOpen, setIsOpen] = useState({
    advanced: false,
    general: true,
    business: false,
    medicaid:false,
    trustAdmin:false
  });
  const [isExistingBusiness, setIsExistingBusiness] = useState({
    exists: false,
    businessPurchase: false,
    hasBeenTouched: false,
  });
  const toggle = (e) => {
    console.log(e.target.getAttribute("opener"));
    const opener = e.target.getAttribute("opener");
    const id = e.target.id;
    setIsOpen((ps) => {
      const openObj = {
        ...ps,
      };
      openObj[opener] = !openObj[opener];
      return openObj;
    });
  };

  //matches quantities object key to formatted name of item purchased (used for itemdescription in checkout window)
  const [quantNamesObj, setQuantNamesObj] = useState({
    WealthGuard: "Wealth Guard - Custom RLT",
    NYCWealthGuard: "(NYC) Wealth Guard Plan - Custom RLT",
    wealthGuardNoDeed: "Wealth Guard - Custom RLT (No Deed)",
    NYCWealthGuardNoDeed: "(NYC) Wealth Guard Plan - Custom RLT (No Deed)",
    RLTProv: "RLT with SNT Provision",
    livingSNT: "Living SNT",
    livingSNTRLT: "Living SNT with RLT",
    LLCFormation: "LLC Corporate Formation",
    CorporateFormation: "",
    LLCWealth: "LLC Corp with Wealth Guard Plan",
    NYLLCWealth: "LLC Corp with Wealth Guard Plan",
    CorpWealth: "",
    IDGT: "Intentionally Defective Grantor Trust",
    MAPT: "Medicaid Asset Protected Trust",
    DAPT: "Domestic Asset Protection Trust",
    CRUT: "Charitable Trust",
    LAPT: "Lifetime Asset Protected Trust",
    NYCLAPT: "Lifetime Asset Protected Trust",
    CMT: "Credit Maximation Trust or Remarriage Provision",
    NYCCMT: "Credit Maximation Trust or Remarriage Provision",
    deeds: "Additional Deed",
    ILDeeds: "(Illinois) Additional Deed",
    affidavit: "Affidavit of Death of Joint Tenant",
    assignments: "Assignment of Business",
    notary: "Notary Included",
    eRecording: "Electronic Recording",
    customItem: "",
    powerOfAttorneyI: "Power of Attorney Package - Individual",
    powerOfAttorneyJ: "Power of Attorney Package - Joint",
    corporateKit: "Corporate Kit",
    familyOperating: "Private Family Foundation Operating",
    familyNonOperating: "Private Family Foundation Non-Operating",
    standaloneBuySell: "Stand Alone Buy/Sell Agreement",
    standaloneBuySellFormatted: "Stand Alone Buy%2FSell Agreement",
    buySellBusinessFormatted: "Buy%2FSell with Business Formation",
    buySellBusiness: "Buy/Sell with Business Formation",
    irrevocableLIT: "Irrevocable Life Insurance Trust",
    bridgeTrust: "Bridge Trust",
    dynastyRevocable: "Dynasty Revocable Trust",
    dynastyIrrevocable: "Dynasty Irrevocable Trust",
    designDepositQuantity: "Design Meeting Deposit",
    trademarkApp: "Trademark Application",
    trademarkClassFee: "Trademark-Additional Class Fee",
    bPetTrust: "Basic Pet Trust",
    cPetTrust: "Customized Pet Trust",
    wealthRestatement: "Wealth Guard Restatement",
    bronzeGun: "Bronze Gun Trust",
    silverGun: "Silver Gun Trust",
    goldGun: "Gold Gun Trust",
    basicCorp: "Basic Corporation Formation",
    basicLLC: "Basic LLC Formation",
    basicCorpWealth: "Basic Corporation Formation with Wealth Guard Plan",
    basicLLCWealth: "Basic LLC Formation with Wealth Guard Plan",
    enhancedCorp: "Enhanced Corporation Formation",
    enhancedLLC: "Enhanced LLC Formation",
    enhancedCorpWealth: "Enhanced Corporation Formation with Wealth Guard Plan",
    enhancedLLCWealth: "Enhanced LLC Formation with Wealth Guard Plan",
    advancedCorp: "Advanced Corporation Formation",
    advancedLLC: "Advanced LLC Formation",
    advancedCorpWealth: "Advanced Corporation Formation with Wealth Guard Plan",
    advancedLLCWealth: "Advanced LLC Formation with Wealth Guard Plan",
    strategyReport:"Strategy Report",
    nonCrisis:"Non-Crisis Planning",
    crisis:"Crisis Planning",
    platFunding:"WealthGuard Platinum Funding",
    premFundingAst:"Additional Platinum Funding Item",
    smallEstatePkg:"Small Estate Package",
    trustUpdate:"Trust Update",
    abcFunding:"AB or ABC Funding",
    addtlDeathAffidavit:"Additional Affidavits of Death",
    addtlAccount:"Additional Accounts",
    distrBenef:"Distribution to Beneficiaries Outright",
    benef2or1:"Distribution to 2 Beneficiaries Outright or 1 Beneficiary in LAPT",
    benefLAPT:"Distribution to 2 Beneficiaries in LAPT",
    lifetimeBenef:"Additional Lifetime Beneficiary",
    outrightBenef:"Additional Outright Beneficiaries",
    complications:"Additional Complex Situations",
    surviveSpouse:"For Surviving Spouse",
    afterSurviveSpouse:"For Successor Trustee After Surviving Spouse",
    rushFee:"Rush Fee",
    changeofTrustee:"Affidavit Change of Trustee",
    addtlRealEstate:"Additional Real Estate",
    addtlProp:"Additional Property",



  });
  const [couponInput, setCouponInput] = useState({
    codeInput: "",
    promoCodeInput: "",
    clientEmail: "",
    pctOff: "",
    dollarOff: "",
    displayDiscount: "",
    pctOrDollar: "",
    depositAmount: 0,
  });
  const [promoCodes, setPromoCodes] = useState({
    MOMS25: {
      value: 0,
      operator: "add",
      restriction: true,
    },
    BRIDGE10: {
      value: .10,
      operator: "divide",
      restriction: true,
    },
    used: {},
  });


  ///confirmInput is the data already existing in the matter in lawmatics
  ///so if they have already purchased a trust guard plan, and they purchase another one, we will push to lawmatics that they have purchased 2 total
  const [confirmInput, setConfirmInput] = useState({
    clientConfirm: "",
    processorConfirm: "",
    processorConfirmId: null,
    searchedClient: false,
    clientId: null,
    spouseConfirm: 0,
    retreivedQuantities: {
      wealthNumber: 0,
      RLTSNTnumber: 0,
      livingSNTNumber: 0,
      SNTwRLTnumber: 0,
      LLCcorpNumber: 0,
      LLCcorpwWealthNumber: 0,
      IDGTNumber: 0,
      MAPTNumber: 0,
      DAPTNumber: 0,
      CRUTNumber: 0,
      LAPTNumber: 0,
      CMTNumber: 0,
      deedNumber: 0,
      assignNumber: 0,
      isCustomNotary: false,
      recordingNumber: 0,
      waveFee: false,
      deedsToBeDrafted: 0,
      powerOfAttorneyI: 0,
      powerOfAttorneyJ: 0,
      corporateKit: 0,
      irrevocableLITNumber: 0,
      bridgeTrust: 0,
      dynastyIrrevocableNumber: 0,
      dynastyRevocableNumber: 0,
      designDepositQuantity: 0,
      depositAmount: 0,
      trademarkApp: 0,
      trademarkClassFee: 0,
      affidavitNumber: 0,
      bPetTrust: 0,
      cPetTrust: 0,
      wealthRestatement: 0,
      bronzeGun: 0,
      silverGun: 0,
      goldGun: 0,
      basicCorp: 0,
      basicLLC: 0,
      basicCorpWealth: 0,
      basicLLCWealth: 0,
      enchancedCorp: 0,
      enhancedLLC: 0,
      enhancedCorpWealth: 0,
      enhancedLLCWealth: 0,
      advancedCorp: 0,
      advancedLLC: 0,
      advancedCorpWealth: 0,
      advancedLLCWealth: 0,
      strategyReport:0,
    nonCrisis:0,
    crisis:0,
    platFunding:0,
    premFundingAst:0,
    smallEstatePkg:0,
    trustUpdate:0,
    abcFunding:0,
    addtlDeathAffidavit:0,
    addtlAccount:0,
    distrBenef:0,
    benef2or1:0,
    benefLAPT:0,
    lifetimeBenef:0,
    outrightBenef:0,
    complications:0,
    surviveSpouse:0,
    afterSurviveSpouse:0,
    rushFee:0,
    changeofTrustee:0,
    addtlProp:0,
    addtlRealEstate:0

    },
  });
  const [prices, setPrices] = useState({
    WealthGuard: "3900",
    NYCWealthGuard: "4900",
    wealthGuardNoDeed: "3900",
    NYCWealthGuardNoDeed: "4900",
    LLCFormation: "1950.00",
    LLCWealth: "1750.00",
    RLTProv: "4200.00",
    livingSNT: "5000.00",
    livingSNTRLT: "6500.00",
    deeds: "200.00",
    ILDeeds: "350.00",
    affidavit: "250.00",
    assignments: "250.00",
    IDGT: "6000",
    MAPT: "6000",
    DAPT: "6000",
    CRUT: "6000",
    LAPT: "1000",
    CMT: "1000",
    notary: "200",
    eRecording: "50",
    waveFee: "-600",
    powerOfAttorneyI: "700",
    powerOfAttorneyJ: "1200",
    corporateKit: "125",
    familyNonOperating: "6000",
    familyOperating: "8000",
    standaloneBuySell: "5000",
    buySellBusiness: "6750",
    irrevocableLIT: "6000",
    bridgeTrust: "32000",
    dynastyRevocable: "9500",
    dynastyIrrevocable: "12500",
    designDepositQuantity: "250",
    trademarkApp: "1500",
    trademarkClassFee: "400",
    bPetTrust: "500",
    cPetTrust: "1000",
    wealthRestatement: "3000",
    bronzeGun: "1500",
    silverGun: "2500",
    goldGun: "3500",
    basicCorp: "2500",
    basicLLC: "2500",
    basicCorpWealth: "2000",
    basicLLCWealth: "2000",
    enhancedCorp: "3500",
    enhancedLLC: "3500",
    enhancedCorpWealth: "3000",
    enhancedLLCWealth: "3000",
    advancedCorp: "5500",
    advancedLLC: "5500",
    advancedCorpWealth: "5000",
    advancedLLCWealth: "5000",
    strategyReport:"3000",
    nonCrisis:"12500",
    crisis:"15500",
    premFundingAst:"100",
    platFunding:"2000",
    smallEstatePkg:"1000",
    trustUpdate:"1000",
    abcFunding:"7000",
    addtlDeathAffidavit:"250",
    addtlAccount:"1000",
    distrBenef:"5000",
    benef2or1:"5500",
    benefLAPT:"6000",
    lifetimeBenef:"1000",
    outrightBenef:"500",
    complications:"1000",
    surviveSpouse:"750",
    afterSurviveSpouse:"1250",
    rushFee:"250",
    changeofTrustee:"250",
    addtlProp:"500",
    addtlRealEstate:"1000",
    customItem: "0",
  });

  const [quantities, setQuantities] = useState({
    WealthGuard: "0",
    NYCWealthGuard: "0",
    wealthGuardNoDeed: "0",
    NYCWealthGuardNoDeed: "0",
    LLCFormation: "0",
    LLCWealth: "0",
    RLTProv: "0",
    livingSNT: "0",
    livingSNTRLT: "0",
    affidavit: "0",
    deeds: "0",
    ILDeeds: "0",
    assignments: "0",
    IDGT: "0",
    MAPT: "0",
    DAPT: "0",
    CRUT: "0",
    LAPT: "0",
    CMT: "0",
    notary: "0",
    eRecording: "0",
    waveFee: "0",
    customItem: "0",
    powerOfAttorneyI: "0",
    powerOfAttorneyJ: "0",
    familyNonOperating: "0",
    familyOperating: "0",
    standaloneBuySell: "0",
    buySellBusiness: "0",
    irrevocableLIT: "0",
    bridgeTrust: "0",
    dynastyIrrevocable: "0",
    dynastyRevocable: "0",
    corporateKit: "0",
    designDepositQuantity: "0",
    trademarkApp: "0",
    trademarkClassFee: "0",
    bPetTrust: "0",
    cPetTrust: "0",
    wealthRestatement: "0",
    bronzeGun: "0",
    silverGun: "0",
    goldGun: "0",
    basicCorp: "0",
    basicLLC: "0",
    basicCorpWealth: "0",
    basicLLCWealth: "0",
    enhancedCorp: "0",
    enhancedLLC: "0",
    enhancedCorpWealth: "0",
    enhancedLLCWealth: "0",
    advancedCorp: "0",
    advancedLLC: "0",
    advancedCorpWealth: "0",
    advancedLLCWealth: "0",
    strategyReport:"0",
    nonCrisis:"0",
    crisis:"0",
    platFunding:"0",
    premFundingAst:"0",
    smallEstatePkg:"0",
    trustUpdate:"0",
    abcFunding:"0",
    addtlDeathAffidavit:"0",
    addtlAccount:"0",
    distrBenef:"0",
    benef2or1:"0",
    benefLAPT:"0",
    lifetimeBenef:"0",
    outrightBenef:"0",
    complications:"0",
    surviveSpouse:"0",
    afterSurviveSpouse:"0",
    rushFee:"0",
    changeofTrustee:"0",
    addtlProp:"0",
    addtlRealEstate:"0",
    surviveSpouse:"0",
  });
  const [cartTotal, setCartTotal] = useState({
    finalPrice: 0,
    appliedDiscounts: 0,
    actualValue: 0,
    preDiscountPrice: 0,
    depositAmount: 0,
  });
  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  ///these changeLLCAndCorp function are just to change the display of what you see in the cart depending on if the purchase is an LLC or corporation
  ///they are basically the exact same thing, we just needed to have them be visually distinct, so this function changes out the div in the shop 
  function changeLLCAndCorp(e) {
    setShopItems((prevState) => {
      const pd = {
        ...prevState,
      };
      const shopTitle = e.target.id.toString();
      console.log(e.target.title);
      pd.businessPlanning[e.target.title].title = (
        <div class="dropdown-center">
          <button
            data-bs-toggle="dropdown"
            style={{
              "text-align": "left",
              "font-weight": "bold",
              "font-size": "1em",
              color: "#333",
              "padding-left": "0px",
            }}
            className="shopToggleButton btn btn-clear dropdown-toggle"
            aria-expanded="false"
          >
            {shopTitle}
          </button>
          <ul class="dropdown-menu">
            <li>
              <div
                class="dropdown-item"
                id={
                  e.target.title === "0"
                    ? "Corporate Formation"
                    : "Corporation with Wealth Guard Plan"
                }
                onClick={changeLLCAndCorp}
                title={e.target.title}
              >
                {e.target.title === "0"
                  ? "Corporate Formation"
                  : "Corporation with Wealth Guard Plan"}
              </div>
            </li>
            <li>
              <div
                class="dropdown-item"
                title={e.target.title}
                id={
                  e.target.title === "0"
                    ? "LLC Formation"
                    : "LLC Formation with Wealth Guard Plan"
                }
                onClick={changeLLCAndCorp}
              >
                {e.target.title === "0"
                  ? "LLC Formation"
                  : "LLC Formation with Wealth Guard Plan"}
              </div>
            </li>
          </ul>
        </div>
      );
      if (
        shopTitle === "Corporate Formation" ||
        shopTitle === "Corporation with Wealth Guard Plan"
      ) {
        pd.llcOrCorp.noWealth = "corp";
        pd.businessPlanning[0].extras.display = true;
      } else {
        pd.llcOrCorp.noWealth = "llc";
        pd.businessPlanning[0].extras.display = false;
      }
      return pd;
    });
  }
  function changeLLCAndCorp2(e) {
    const shopId = e.target.id.toString();
    const otherId = e.target.title;
    const thirdId = e.target.getAttribute("data-third-type");
    const itemGroup = e.target.getAttribute("itemGroup");
    if (thirdId) {
      let shopItemIndex = 0;
      for (let i = 0; i < shopItems[itemGroup].length; i++) {
        const currentItem = shopItems[itemGroup][i];
        if (
          shopId === currentItem.shownName1 ||
          shopId === currentItem.shownName2 ||
          shopId === currentItem.shownName3
        ) {
          shopItemIndex = i;
        }
      }

      const oldName = shopItems[itemGroup][shopItemIndex].name;
      const oldFullName = quantNamesObj[oldName];
      const newName = getKeyByValue(quantNamesObj, shopId);
      const newPrice = prices[newName];

      if (oldFullName != shopId) {
        setShopItems((prevState) => {
          const pd = {
            ...prevState,
          };
          // console.log(target);
          pd[itemGroup][shopItemIndex].title = (
            <div class="dropdown-center">
              <button
                data-bs-toggle="dropdown"
                style={{
                  "text-align": "left",
                  "font-weight": "bold",
                  "font-size": "1em",
                  color: "#333",
                  "padding-left": "0px",
                }}
                className="shopToggleButton btn btn-clear dropdown-toggle"
                aria-expanded="false"
              >
                {shopId}
              </button>
              <ul class="dropdown-menu">
                <li>
                  <div
                    class="dropdown-item"
                    id={shopId}
                    title={otherId}
                    data-third-type={thirdId}
                    itemGroup={itemGroup}
                    onClick={changeLLCAndCorp2}
                  >
                    {shopId}
                  </div>
                </li>
                <li>
                  <div
                    class="dropdown-item"
                    id={otherId}
                    title={shopId}
                    data-third-type={thirdId}
                    itemGroup={itemGroup}
                    onClick={changeLLCAndCorp2}
                  >
                    {otherId}
                  </div>
                </li>
                <li>
                  <div
                    class="dropdown-item"
                    id={thirdId}
                    title={shopId}
                    data-third-type={otherId}
                    itemGroup={itemGroup}
                    onClick={changeLLCAndCorp2}
                  >
                    {thirdId}
                  </div>
                </li>
              </ul>
            </div>
          );

          pd[itemGroup][shopItemIndex].price = `$${numberWithCommas(
            newPrice
          )}.00`;
          pd[itemGroup][shopItemIndex].name = newName;
          setQuantities((pd) => {
            const ps = { ...pd };
            ps[newName] = ps[oldName];
            ps[oldName] = 0;
            return ps;
          });
          return pd;
        });
      }
    } else {
      let shopItemIndex = 0;
      console.log(itemGroup);
      for (let i = 0; i < shopItems[itemGroup].length; i++) {
        const currentItem = shopItems[itemGroup][i];
        if (
          shopId === currentItem.shownName1 ||
          shopId === currentItem.shownName2
        ) {
          shopItemIndex = i;
          //console.log(i)
        }
      }

      const oldName = shopItems[itemGroup][shopItemIndex].name;
      const oldFullName = quantNamesObj[oldName];
      const newName = getKeyByValue(quantNamesObj, shopId);
      const newPrice = prices[newName];

      if (oldFullName != shopId) {
        setShopItems((prevState) => {
          const pd = {
            ...prevState,
          };
          // console.log(target);
          pd[itemGroup][shopItemIndex].title = (
            <div class="dropdown-center">
              <button
                data-bs-toggle="dropdown"
                style={{
                  "text-align": "left",
                  "font-weight": "bold",
                  "font-size": "1em",
                  color: "#333",
                  "padding-left": "0px",
                }}
                className="shopToggleButton btn btn-clear dropdown-toggle"
                aria-expanded="false"
              >
                {shopId}
              </button>
              <ul class="dropdown-menu">
                <li>
                  <div
                    class="dropdown-item"
                    id={shopId}
                    title={otherId}
                    onClick={changeLLCAndCorp2}
                    itemGroup={itemGroup}
                  >
                    {shopId}
                  </div>
                </li>
                <li>
                  <div
                    class="dropdown-item"
                    id={otherId}
                    title={shopId}
                    onClick={changeLLCAndCorp2}
                    itemGroup={itemGroup}
                  >
                    {otherId}
                  </div>
                </li>
              </ul>
            </div>
          );

          pd[itemGroup][shopItemIndex].price = `$${numberWithCommas(
            newPrice
          )}.00`;
          pd[itemGroup][shopItemIndex].name = newName;
          setQuantities((pd) => {
            const ps = { ...pd };
            ps[newName] = ps[oldName];
            ps[oldName] = 0;
            return ps;
          });
          return pd;
        });
      }
    }
  }

  ////this is just what we offer to purchase, it gets mapped down into the actual jsx down below
  /////if we are offering a new item, place it here
  const [shopItems, setShopItems] = useState({
 
    generalEstate: [
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Wealth Guard - Custom RLT
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Wealth Guard - Custom RLT"
                  title="Wealth Guard - Custom RLT (No Deed)"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Wealth Guard - Custom RLT
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Wealth Guard - Custom RLT (No Deed)"
                  title="Wealth Guard - Custom RLT"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Wealth Guard - Custom RLT (No Deed)
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$3,900.00",
        name: "WealthGuard",
        display: true,
        shownName1: "WealthGuard - Custom RLT",
        shownName2: "WealthGuard - Custom RLT (No Deed)",
        key: 0,
        extras: {
          display: quantities["WealthGuard"] > 0 ? false : true,
          title: "Lifetime Asset Protected Trust",
          price: "$1,000.00",
          name: "LAPT",
        },
        extras2: {
          display: quantities["WealthGuard"] > 0 ? false : true,
          title: "Credit Maximation Trust / Remarriage Provisions",
          price: "$1,000.00",
          name: "CMT",
        },
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              (NYC) Wealth Guard - Custom RLT
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="(NYC) Wealth Guard Plan - Custom RLT"
                  title="(NYC) Wealth Guard Plan - Custom RLT (No Deed)"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  (NYC) Wealth Guard - Custom RLT
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="(NYC) Wealth Guard Plan - Custom RLT (No Deed)"
                  title="(NYC) Wealth Guard Plan - Custom RLT"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  (NYC) Wealth Guard - Custom RLT (No Deed)
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$4,900.00",
        name: "NYCWealthGuard",
        display: true,
        shownName1: "(NYC) Wealth Guard Plan - Custom RLT",
        shownName2: "(NYC) Wealth Guard Plan - Custom RLT (No Deed)",
        key: 0,
        extras: {
          display: quantities["NYCWealthGuard"] > 0 ? false : true,
          title: "Lifetime Asset Protected Trust",
          price: "$1,000.00",
          name: "LAPT",
        },
        extras2: {
          display: quantities["NYCWealthGuard"] > 0 ? false : true,
          title: "Credit Maximation Trust / Remarriage Provisions",
          price: "$1,000.00",
          name: "CMT",
        },
      },
      {
        title: "WealthGuard Platinum Funding",
        price: "$2,000.00",
        name: "platFunding",
        display: true,
        key: 0,
         disclaimer:
          "(This includes up to 10 accounts --  Real Estate or Business Assignments  are not included) ",
        extras: {
          display: quantities["platFunding"] > 0 ? false : true,
          title: "Additional Platinum Funding Item",
          price: "$100.00",
          name: "premFundingAst",
          // disclaimer:
          // "(This includes up to 10 accounts --  Real Estate or Business Assignments  are not included) ",
        },
      },
       {
        title: "Additional Platinum Funding Item",
        price: "$100.00",
        name: "premFundingAst",
        display: false,
        disclaimer:
          "(This includes up to 10 accounts --  Real Estate or Business Assignments  are not included) ",
      },
      // {
      //   title: "(NYC) Wealth Guard - Custom RLT",
      //   price: "$4,250.00",
      //   name: "NYCWealthGuard",
      //   display: false,
      //   key: 0,
      // },
      // {
      //   title: "Wealth Guard - Custom RLT (No Deed)",
      //   price: "$3,500.00",
      //   name: "wealthGuardNoDeed",
      //   display: false,
      //   key: 0,
      // },
      // {
      //   title: "(NYC) Wealth Guard - Custom RLT (No Deed)",
      //   price: "$4,250.00",
      //   name: "NYCWealthGuardNoDeed",
      //   display: false,
      //   key: 0,
      // },
      {
        title: "RLT w/SNT Provisions",
        price: "$4,200.00",
        name: "RLTProv",
        display: true,
        key: 1,
      },
      {
        title: "Living SNT (Standalone 3rd Party)",
        price: "$5,000.00",
        name: "livingSNT",
        display: true,
        key: 2,
      },
      {
        title: "Living SNT w/RLT",
        price: "$6,500.00",
        name: "livingSNTRLT",
        display: true,
        key: 3,
      },

      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Power of Attorney Package - Individual
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Power of Attorney Package - Individual"
                  title="Power of Attorney Package - Joint"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Power of Attorney Package - Individual
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Power of Attorney Package - Joint"
                  title="Power of Attorney Package - Individual"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Power of Attorney Package - Joint
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$700.00",
        name: "powerOfAttorneyI",
        display: true,
        shownName1: "Power of Attorney Package - Joint",
        shownName2: "Power of Attorney Package - Individual",
        key: 92,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Basic Pet Trust
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Basic Pet Trust"
                  title="Customized Pet Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Basic Pet Trust
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Customized Pet Trust"
                  title="Basic Pet Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Customized Pet Trust
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$500.00",
        name: "bPetTrust",
        display: true,
        shownName1: "Customized Pet Trust",
        shownName2: "Basic Pet Trust",
      },
      {
        title: "Wealth Guard Restatement",
        price: "$3,000.00",
        name: "wealthRestatement",
        display: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Bronze Gun Trust
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Bronze Gun Trust"
                  title="Silver Gun Trust"
                  data-third-type="Gold Gun Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Bronze Gun Trust
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Silver Gun Trust"
                  title="Bronze Gun Trust"
                  data-third-type="Gold Gun Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Silver Gun Trust
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Gold Gun Trust"
                  title="Silver Gun Trust"
                  data-third-type="Bronze Gun Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"generalEstate"}
                >
                  Gold Gun Trust
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$1,500.00",
        name: "bronzeGun",
        display: true,
        shownName1: "Bronze Gun Trust",
        shownName2: "Silver Gun Trust",
        shownName3: "Gold Gun Trust",
      },
 
      {
        title: "Custom Item",
        price: "$0.00",
        name: "customItem",
        display: false,
        key: 11,
      },
    ],
    advancedEstate: [
      {
        title: "Intentionally Defective Grantor Trust (IDGT)",
        price: "$6,000.00",
        name: "IDGT",
        display: true,
        key: 4,
      },
      {
        title: "Domestic Asset Protection Trust (DAPT)",
        price: "$6,000.00",
        name: "DAPT",
        display: true,
        key: 6,
      },
      {
        title: "Charitable Trust",
        price: "$6,000.00",
        name: "CRUT",
        display: true,
        key: 7,
      },

      {
        title: "Lifetime Asset Protected Trust",
        price: "$1,000.00",
        name: "LAPT",
        display: false,
        key: 8,
      },
      {
        title: "Credit Maximation Trust / Remarriage Provisions",
        price: "$1,000.00",
        name: "CMT",
        display: false,
        key: 9,
      },

      {
        title: "Irrevocable Life Insurance Trust",
        price: "$6,000.00",
        name: "irrevocableLIT",
        display: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Private Family Foundation Operating
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Private Family Foundation Operating"
                  title="Private Family Foundation Non-Operating"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"advancedEstate"}
                >
                  Private Family Foundation Operating
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Private Family Foundation Non-Operating"
                  title="Private Family Foundation Operating"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"advancedEstate"}
                >
                  Private Family Foundation Non-Operating
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$8,000.00",
        name: "familyOperating",
        display: true,
        shownName1: "Private Family Foundation Operating",
        shownName2: "Private Family Foundation Non-Operating",
        key: 93,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Dynasty Revocable Trust
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Dynasty Revocable Trust"
                  title="Dynasty Irrevocable Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"advancedEstate"}
                >
                  Dynasty Revocable Trust
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Dynasty Irrevocable Trust"
                  title="Dynasty Revocable Trust"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"advancedEstate"}
                >
                  Dynasty Irrevocable Trust
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$9,500.00",
        name: "dynastyRevocable",
        display: true,
        shownName1: "Dynasty Revocable Trust",
        shownName2: "Dynasty Irrevocable Trust",
        key: 93,
      },
      {
        title: "Bridge Trust",
        price: "$32,000.00",
        name: "bridgeTrust",
        display: true,
      },
    ],
    businessPlanning: [
      // {
      //   title: (
      //     <div class="dropdown-center">
      //       <button
      //         data-bs-toggle="dropdown"
      //         style={{
      //           "text-align": "left",
      //           "font-weight": "bold",
      //           "font-size": "1em",
      //           color: "#333",
      //           "padding-left": "0px",
      //         }}
      //         className="shopToggleButton btn btn-clear dropdown-toggle"
      //         aria-expanded="false"
      //       >
      //         LLC Formation
      //       </button>
      //       <ul class="dropdown-menu">
      //         <li>
      //           <div
      //             class="dropdown-item"
      //             id="Corporate Formation"
      //             title="0"
      //             onClick={changeLLCAndCorp}
      //             itemGroup={"businessPlanning"}
      //           >
      //             Corporate Formation
      //           </div>
      //         </li>
      //         <li>
      //           <div
      //             class="dropdown-item"
      //             title="0"
      //             id="LLC Formation"
      //             onClick={changeLLCAndCorp}
      //             itemGroup={"businessPlanning"}
      //           >
      //             LLC Formation
      //           </div>
      //         </li>
      //       </ul>
      //     </div>
      //   ),
      //   price: "$1,950.00",
      //   name: "LLCFormation",
      //   display: true,
      //   extras: {
      //     display: false,
      //     title: "Corporate Kit",
      //     price: "$125.00",
      //     name: "corporateKit",
      //   },
      //   key: 90,
      //   shownName1: "LLC Formation",
      //   shownName2: "Corporate Formation",
      // },
      // {
      //   title: (
      //     <div class="dropdown-center">
      //       <button
      //         data-bs-toggle="dropdown"
      //         style={{
      //           "text-align": "left",
      //           "font-weight": "bold",
      //           "font-size": ".8em",
      //           color: "#333",
      //           "padding-left": "0px",
      //         }}
      //         className="shopToggleButton btn btn-clear dropdown-toggle"
      //         aria-expanded="false"
      //       >
      //         LLC With Wealth Guard Plan
      //       </button>
      //       <ul class="dropdown-menu">
      //         <li>
      //           <div
      //             class="dropdown-item"
      //             id="Corporation with Wealth Guard Plan"
      //             onClick={changeLLCAndCorp}
      //             itemGroup={"businessPlanning"}
      //             title="6"
      //           >
      //             Corporation with Wealth Guard Plan
      //           </div>
      //         </li>
      //         <li>
      //           <div
      //             class="dropdown-item"
      //             title="6"
      //             id="LLC With Wealth Guard Plan"
      //             onClick={changeLLCAndCorp}
      //             itemGroup={"businessPlanning"}
      //           >
      //             LLC With Wealth Guard Plan
      //           </div>
      //         </li>
      //       </ul>
      //     </div>
      //   ),
      //   price: "$1,750.00",
      //   name: "LLCWealth",
      //   display: true,
      //   key: 91,
      // },
      ///////////////////////////////////
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": ".8em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Basic Corporation Formation
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Basic Corporation Formation"
                  title="Basic LLC Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Basic Corporation Formation
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Basic LLC Formation"
                  title="Basic Corporation Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Basic LLC Formation
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$2,500.00",
        name: "basicCorp",
        display: true,
        shownName1: "Basic Corporation Formation",
        shownName2: "Basic LLC Formation",
        displayFilingFeeNote: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": ".8em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Basic Corporation Formation with Wealth Guard Plan
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Basic Corporation Formation with Wealth Guard Plan"
                  title="Basic LLC Formation with Wealth Guard Plan"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Basic Corporation Formation with Wealth Guard Plan
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Basic LLC Formation with Wealth Guard Plan"
                  title="Basic Corporation Formation with Wealth Guard Plan"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Basic LLC Formation with Wealth Guard Plan
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$2,000.00",
        name: "basicCorpWealth",
        display: true,
        shownName1: "Basic Corporation Formation with Wealth Guard Plan",
        shownName2: "Basic LLC Formation with Wealth Guard Plan",
        displayFilingFeeNote: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": ".8em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Enhanced Corporation Formation
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Enhanced Corporation Formation"
                  title="Enhanced LLC Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Enhanced Corporation Formation
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Enhanced LLC Formation"
                  title="Enhanced Corporation Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Enhanced LLC Formation
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$3,500.00",
        name: "enhancedCorp",
        display: true,
        shownName1: "Enhanced Corporation Formation",
        shownName2: "Enhanced LLC Formation",
        displayFilingFeeNote: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": ".8em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Enhanced Corporation Formation With Wealth Guard Plan
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Enhanced Corporation Formation with Wealth Guard Plan"
                  title="Enhanced LLC Formation with Wealth Guard Plan"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Enhanced Corporation Formation With Wealth Guard Plan
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Enhanced LLC Formation with Wealth Guard Plan"
                  title="Enhanced Corporation Formation with Wealth Guard Plan"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Enhanced LLC Formation With Wealth Guard Plan
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$3,000.00",
        name: "enhancedCorpWealth",
        display: true,
        shownName1: "Enhanced Corporation Formation with Wealth Guard Plan",
        shownName2: "Enhanced LLC Formation with Wealth Guard Plan",
        displayFilingFeeNote: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": ".8em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Advanced Corporation Formation
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Advanced Corporation Formation"
                  title="Advanced LLC Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Advanced Corporation Formation
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Advanced LLC Formation"
                  title="Advanced Corporation Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Advanced LLC Formation
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$5,500.00",
        name: "advancedCorp",
        display: true,
        shownName1: "Advanced Corporation Formation",
        shownName2: "Advanced LLC Formation",
        displayFilingFeeNote: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": ".8em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Advanced Corporation Formation with Wealth Guard Plan
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Advanced Corporation Formation with Wealth Guard Plan"
                  title="Advanced LLC Formation with Wealth Guard Plan"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Advanced Corporation Formation with Wealth Guard Plan
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Advanced LLC Formation with Wealth Guard Plan"
                  title="Advanced Corporation Formation with Wealth Guard Plan"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Advanced LLC Formation with Wealth Guard Plan
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$5,000.00",
        name: "advancedCorpWealth",
        display: true,
        shownName1: "Advanced Corporation Formation with Wealth Guard Plan",
        shownName2: "Advanced LLC Formation with Wealth Guard Plan",
        displayFilingFeeNote: true,
      },
      //////

      {
        title: "Trademark Application",
        price: "$1,500.00",
        name: "trademarkApp",
        display: true,
      },
      {
        title: "Trademark-Additional Class Fee",
        price: "$400.00",
        name: "trademarkClassFee",
        display: true,
      },
      {
        title: (
          <div class="dropdown-center">
            <button
              data-bs-toggle="dropdown"
              style={{
                "text-align": "left",
                "font-weight": "bold",
                "font-size": "1em",
                color: "#333",
                "padding-left": "0px",
              }}
              className="shopToggleButton btn btn-clear dropdown-toggle"
              aria-expanded="false"
            >
              Stand Alone Buy/Sell Agreement
            </button>
            <ul class="dropdown-menu">
              <li>
                <div
                  class="dropdown-item"
                  id="Stand Alone Buy/Sell Agreement"
                  title="Buy/Sell with Business Formation"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Stand Alone Buy/Sell Agreement
                </div>
              </li>
              <li>
                <div
                  class="dropdown-item"
                  id="Buy/Sell with Business Formation"
                  title="Stand Alone Buy/Sell Agreement"
                  onClick={changeLLCAndCorp2}
                  itemGroup={"businessPlanning"}
                >
                  Buy/Sell with Business Formation
                </div>
              </li>
            </ul>
          </div>
        ),
        price: "$5,000.00",
        name: "standaloneBuySell",
        display: true,
        shownName1: "Stand Alone Buy/Sell Agreement",
        shownName2: "Buy/Sell with Business Formation",
      },
      {
        title: "Corporate Kit",
        price: "$125.00",
        name: "corporateKit",
        display: false,
        key: 12,
      },
    ],
    medicaidPlanning:[
 {
        title: "Crisis Planning",
        price: "$15,500.00",
        name: "crisis",
        display: true,
        key: 7,
      },
       {
        title: "Non-Crisis Planning",
        price: "$12,500.00",
        name: "nonCrisis",
        display: true,
        key: 7,
      },
       {
        title: "Strategy Report",
        price: "$3,000.00",
        name: "strategyReport",
        display: true,
        key: 7,
      },
            {
        title: "Medicaid Asset Protected Trust (MAPT)",
        price: "$6,000.00",
        name: "MAPT",
        display: true,
        key: 5,
      },
    ],

    options: [
      {
        title: "Design Meeting Deposit",
        price: "$250.00",
        name: "designDepositQuantity",
        disclaimer: "",
        display: true,
      },
      {
        title: "Additional Deeds",
        price: "$200.00",
        name: "deeds",
        disclaimer:
          "(Includes Electronic Recording Where Available - County Recorder Fees Are Additional)",
      },
      {
        title: "Additional Deeds (Illinois)",
        price: "$350.00",
        name: "ILDeeds",
        disclaimer: "",
      },
      {
        title: "Affidavit of Death of Joint Tenant",
        price: "$250.00",
        name: "affidavit",
        disclaimer: "",
      },
      {
        title: "Assignment of Business",
        price: "$250.00",
        name: "assignments",
        disclaimer: "",
      },
      {
        title: "Notary",
        price: "$200.00",
        name: "notary",
        disclaimer: "(In Home or Office)",
      },

      {
        title: "Agent Plan Discount",
        price: "$-600.00",
        name: "waveFee",
      },
    ],
     trustAdmin: {
      items:[
      {
        title: "Small Estate Package",
        price: "$1,000.00",
        name: "smallEstatePkg",
        disclaimer: "(Includes 1 Trust Certification, 1 Affidavit of Death & Assessor Forms )",
        display: true,
      },
      {
        title: "Trust Update",
        price: "$1,000.00",
        name: "trustUpdate",
        disclaimer:"(Update Will, POA, HCPOA, Medical Directives to remove spouse)",
        display: true,
      },
      {
        title: "AB or ABC Funding",
        price: "$7,000.00",
        name: "abcFunding",
        disclaimer: "(Includes 1 brokerage or retirement account, 1 Life Insurance Policy, 1 Deed and up to 3 bank accounts)    *Unusual assets, partnerships or LLC’s additional",
        display: true,
      },
      {
        title: "Additional Affidavits of Death",
        price: "$250.00",
        name: "addtlDeathAffidavit",
        disclaimer: "",
        display: false,
      },
      {
        title: "Additional Accounts",
        price: "$1,000",
        name: "addtlAccount",
        disclaimer: "",
        display: false,
      },
      ,
      {
        title: "Additional Property",
        price: "$500.00",
        name: "addtlProp",
        disclaimer: "",
        display: false,
      },
      {
        title: "Distribution to Beneficiaries Outright",
        price: "$5,000.00",
        name: "distrBenef",
        disclaimer: "",
        display: false,
      },
      {
        title: "Distribution to 2 Beneficiaries Outright or 1 Beneficiary in LAPT",
        price: "$5,500.00",
        name: "benef2or1",
        disclaimer: "",
        display: false,
      },
      {
        title: "Distribution to 2 Beneficiaries in LAPT",
        price: "$6,000.00",
        name: "benefLAPT",
        disclaimer: "",
        display: false,
      },
       {
        title: "Additional Lifetime Beneficiary",
        price: "$1,000.00",
        name: "lifetimeBenef",
        disclaimer: "",
        display: false,
      },
       {
        title: "Additional Outright Beneficiaries",
        price: "$500.00",
        name: "outrightBenef",
        disclaimer: "",
        display: false,
      },
      {
        title: "Additional Real Estate",
        price: "$1,000.00",
        name: "addtlRealEstate",
        disclaimer: "",
        display: false,
      },
       {
        title: "Additional Complex Situations",
        price: "$1,000.00",
        name: "complications",
        disclaimer: "",
        display: false,
      },{
        title: "For Surviving Spouse",
        price: "$750.00",
        name: "surviveSpouse",
        disclaimer: "(Not including Affidavit of Change of Trustee)",
        display: false,
      },
       {
        title: "For Successor Trustee After Surviving Spouse",
        price: "$1,250.00",
        name: "afterSurviveSpouse",
        disclaimer: "",
        display: false,
      },{
        title: "Rush Fee",
        price: "$250.00",
        name: "rushFee",
        disclaimer: "(If needed within 1 week)",
        display: false,
      },
       {
        title: "Affidavit Change of Trustee",
        price: "$250.00",
        name: "changeofTrustee",
        disclaimer: "(Including assessor forms)",
        display: false,
      }
    
    ],
  addOns1:[
    {
        title: "Additional Affidavits of Death",
        price: "$250.00",
        name: "addtlDeathAffidavit",
        disclaimer: "",
        display: true,
      },
      {
        title: "Additional Accounts",
        price: "$1,000.00",
        name: "addtlAccount",
        disclaimer: "(up to 3 additional)",
        display: true,
      },
      {
        title: "Additional Property",
        price: "$500.00",
        name: "addtlProp",
        disclaimer: "",
        display: true,
      }
  ],  items2:[
    {
        title: "Distribution to Beneficiaries Outright",
        price: "$5,000.00",
        name: "distrBenef",
        disclaimer: "(Beneficiary is also the Trustee, Includes 1 brokerage or retirement account, 1 Life Insurance Policy, 1 Deed and up to 3 bank accounts)",
        display: true,
      },
      {
        title: "Distribution to 2 Beneficiaries Outright or 1 Beneficiary in LAPT",
        price: "$5,500.00",
        name: "benef2or1",
        disclaimer: "",
        display: true,
      },
      {
        title: "Distribution to 2 Beneficiaries in LAPT",
        price: "$6,000.00",
        name: "benefLAPT",
        disclaimer: "",
        display: true,
      },
  ],  addOns2:[
    
      {
        title: "Additional Accounts",
        price: "$1,000.00",
        name: "addtlAccount",
        disclaimer: "(up to 3 additional)",
        display: true,
      },
       {
        title: "Additional Lifetime Beneficiary",
        price: "$1,000.00",
        name: "lifetimeBenef",
        disclaimer: "",
        display: true,
      },
       {
        title: "Additional Outright Beneficiaries",
        price: "$500.00",
        name: "outrightBenef",
        disclaimer: "",
        display: true,
      },
       {
        title: "Additional Real Estate",
        price: "$1,000.00",
        name: "addtlRealEstate",
        disclaimer: "",
        display: true,
      },
       {
        title: "Additional Complex Situations",
        price: "$1,000.00",
        name: "complications",
        disclaimer: "(e.g. disinheritance, small estate affidavits,, unusual assets, client who'll need extra handholding, etc.)",
        display: true,
      }
  ],
stepIn:[{
        title: "For Surviving Spouse",
        price: "$750.00",
        name: "surviveSpouse",
        disclaimer: "(Not including Affidavit of Change of Trustee)",
        display: true,
      },
       {
        title: "For Successor Trustee After Surviving Spouse",
        price: "$1,250.00",
        name: "afterSurviveSpouse",
        disclaimer: "",
        display: true,
      },

],addOns3:[
  {
        title: "Rush Fee",
        price: "$250.00",
        name: "rushFee",
        disclaimer: "(If needed within 1 week)",
        display: true,
      },
       {
        title: "Affidavit Change of Trustee",
        price: "$250.00",
        name: "changeofTrustee",
        disclaimer: "(Including assessor forms)",
        display: true,
      },
]},
    llcOrCorp: {
      noWealth: "llc",
      withWealth: "llc",
    },
  });

  ////we set location and send it over to the checkout component in order to know what was purchased and other retreived data
  const [locationState, setLocationState] = useState({
    notes: "",
    price: 0,
    isCustom: true,
    readyToCheckout: false,
    confidoOrAffirm: "confidoPay",
    spouse: 0,
    fieldAgent: 0,
    agentFeeWaved: false,
    name: "",
    isEPUSA: false,
    epusaContactId: 0,
    epusaCompanyMatterId: false,
    ignCompanyMatterId: 0,
  });

  const nullQuant = {
    WealthGuard: "0",
    NYCWealthGuard: "0",
    wealthGuardNoDeed: "0",
    NYCWealthGuardNoDeed: "0",
    LLCFormation: "0",
    LLCWealth: "0",
    RLTProv: "0",
    livingSNT: "0",
    livingSNTRLT: "0",
    deeds: "0",
    ILDeeds: "0",
    assignments: "0",
    IDGT: "0",
    MAPT: "0",
    DAPT: "0",
    CRUT: "0",
    LAPT: "0",
    CMT: "0",
    notary: "0",
    eRecording: "0",
    waveFee: "0",
    customItem: "0",
    powerOfAttorneyI: "0",
    powerOfAttorneyJ: "0",
    familyNonOperating: "0",
    familyOperating: "0",
    standaloneBuySell: "0",
    buySellBusiness: "0",
    irrevocableLIT: "0",
    dynastyIrrevocable: "0",
    dynastyRevocable: "0",
    corporateKit: "0",
    designDepositQuantity: "0",
    trademarkApp: "0",
    trademarkClassFee: "0",
    affidavit: "0",
    bPetTrust: "0",
    cPetTrust: "0",
    wealthRestatement: "0",
    bronzeGun: "0",
    silverGun: "0",
    goldGun: "0",
    basicCorp: "0",
    basicLLC: "0",
    basicCorpWealth: "0",
    basicLLCWealth: "0",
    enhancedCorp: "0",
    enhancedLLC: "0",
    enhancedCorpWealth: "0",
    enhancedLLCWealth: "0",
    advancedCorp: "0",
    advancedLLC: "0",
    advancedCorpWealth: "0",
    advancedLLCWealth: "0",
    strategyReport:"0",
    nonCrisis:"0",
    crisis:"0",
    platFunding:"0",
    premFundingAst:"0",
    smallEstatePkg:"0",
    trustUpdate:"0",
    abcFunding:"0",
    addtlDeathAffidavit:"0",
    addtlAccount:"0",
    distrBenef:"0",
    benef2or1:"0",
    benefLAPT:"0",
    lifetimeBenef:"0",
    outrightBenef:"0",
    complications:"0",
    surviveSpouse:"0",
    afterSurviveSpouse:"0",
    changeofTrustee:"0",
    surviveSpouse:"0",
    addtlProp:"0",
    addtlRealEstate:"0"
  };


  ///retrieves user list to select who lead attorney is 
  const getAttorneyNames = async () => {
    for (let i = 1; i < 10; i++) {
      const currentPage = i;
      const res = await lawService.getAllAttorneys(currentPage);
      const attorneyAray = res.data.data;
      const totalPages = res.data.meta.total_pages;
      attorneyAray.forEach((element) => {
        setAttorneys((prevState) => {
          let updatedFormData = [...prevState];
          if (element.attributes.name !== " ") {
            updatedFormData.push({
              name: element.attributes.name,
              id: element.id,
            });
          }
          return updatedFormData;
        });
      });
      if (currentPage === totalPages) {
        return;
      }
    }
  };

  const createAttorneyLIst = useEffect(() => {
    getAttorneyNames();
  }, []);

  ///form controller for name input
  const onFormFieldChange = (event) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (name === "waveFee" && value > 1) {
      value = 1;
    }
    setQuantities((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      return updatedFormData;
    });
    console.log(quantities);
  };

  ///coupon form controller
  const onCouponFieldChanged = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setCouponInput((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      return updatedFormData;
    });
  };

  ///lead attorney form controller
  const onConfirmFieldChanged = (event) => {
    const index = event.target?.selectedIndex;
    const currentAttorney = attorneys[index];
    const id = currentAttorney?.id;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setConfirmInput((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      updatedFormData.processorConfirmId = id
        ? id
        : updatedFormData.processorConfirmId;
      return updatedFormData;
    });
  };
  const onConfirmFieldChanged2 = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const trueOrFalse = value === "yes" ? true : false;
    setIsExistingBusiness((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData.exists = trueOrFalse;
      updatedFormData.hasBeenTouched = true;


      return updatedFormData;
    });
    setLoading((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      if(trueOrFalse===false)
        updatedFormData.loading=false


      return updatedFormData;
    });
  };
  function addToCartClicked(e) {
    var title = e.target.name;

    if (quantities["waveFee"] > 0 && title === "waveFee") {
    } else {
      addItemToCart(title);
    }
  }
  function addItemToCart(title) {
    if (quantities[title] !== 0) {
      setQuantities((prevState) => {
        const updatedFormData = {
          ...prevState,
        };
        let quantNum = Number(updatedFormData[title]);
        quantNum = quantNum + 1;
        let quantNumStr = quantNum.toString();
        updatedFormData[title] = quantNumStr;
        return updatedFormData;
      });
    } else {
      setQuantities((prevState) => {
        const updatedFormData = {
          ...prevState,
        };
        updatedFormData[title] = "1";
        return updatedFormData;
      });
    }
  }
///don't worry about this, defunct integration to determine if affirm or confido. never finished the affirm aspect of it
///you may have to later
  const affirmOrConfido = (e) => {
    setLocationState((prevState) => {
      const pd = {
        ...prevState,
      };

      pd.confidoOrAffirm = e.target.id;
      return pd;
    });
  };

  useEffect(() => {
    setCouponInput((prevState) => {
      const pd = {
        ...prevState,
      };
      let discount = cartTotal.preDiscountPrice - cartTotal.finalPrice;
      pd.displayDiscount = discount.toLocaleString();
      return pd;
    });
  }, [cartTotal.finalPrice]);

  const removeCartItem = (e) => {
    var title = e.target.name;
    setQuantities((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[title] = "0";
      return updatedFormData;
    });
  };
  function updateCartTotal() {
    let total = 0;
    let noDiscountTotal = 0;
    let amtOffDislplay = 0;
    for (const cost in quantities) {
      const quant = Number(quantities[cost]);
      const price = Number(prices[cost]);
      total = total + quant * price;
      noDiscountTotal = total;
    }
    if (couponInput.pctOff) {
      var discountAmount = couponInput.pctOff;
      var formattedDiscount = (100 - Number(discountAmount)) * 0.01;
      total = total * formattedDiscount;
      total = Math.floor(total * 100) / 100;
    }
    if (couponInput.dollarOff) {
      var discountAmount = couponInput.dollarOff;
      var formattedDiscount = Number(discountAmount);
      total = total - formattedDiscount;
      total = Math.floor(total * 100) / 100;
    }
    setCartTotal((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.finalPrice = total - couponInput.depositAmount;
      pd.preDiscountPrice = noDiscountTotal;
      return pd;
    });
    setIsExistingBusiness((prevState) => {
      const pd = {
        ...prevState,
      };
      const businessPurchase = decideBusinessPlan();
      pd.businessPurchase = businessPurchase.isBusinessPurchase;
      return pd;
    });
  }
  useEffect(() => {
    updateCartTotal();
  }, [quantities, couponInput.depositAmount]);


  ///so basically this decides if anything business related is being purchased
  const decideBusinessPlan = () => {
    const businessItems = shopItems.businessPlanning;
    const estateItems = shopItems.advancedEstate.concat(
      shopItems.generalEstate,shopItems.medicaidPlanning,shopItems.trustAdmin.items
    );
    let businessInfo = {
      isBusinessPurchase: false,
      isEstatePurchase: false,
      businessValue: 0,
      createNewBusiness: false,
    };
    businessItems.forEach((item) => {
      const quantName = item.name;
      if (quantities[quantName] > 0) {
        businessInfo.isBusinessPurchase = true;
        let price = quantities[quantName] * prices[quantName];
        businessInfo.businessValue = businessInfo.businessValue + price;
      }
    });
    estateItems.forEach((item) => {
      const quantName = item.name;
      if (quantities[quantName] > 0) {
        businessInfo.isEstatePurchase = true;
      }
    });
    if (
      businessInfo.isBusinessPurchase === true &&
      isExistingBusiness.exists === false
    ) {
      businessInfo.createNewBusiness = true;
    }
    businessInfo.businessValue = businessInfo.businessValue * 100;
    return businessInfo;
  };


  //this determines how much money they spent on business planning specifically
  //we push this to its own custom field
  const decideBusinessValue = () => {
    const businessItems = shopItems.businessPlanning;
    let businessValue = 0;
    businessItems.forEach((item) => {
      const quantName = item.name;
      if (quantities[quantName] > 0) {
        let price = quantities[quantName] * prices[quantName];
        businessValue = businessValue + price;
      }
    });
    businessValue = businessValue * 100;
    return businessValue;
  };



  const checkoutClicked = () => {
    if (confirmInput.clientConfirm === "") {
      alert("Please Input Client Name");
    } else if (confirmInput.processorConfirmId === null) {
      alert("Please input Lead Attorney");
    }  else if (agentAttend === "Did Agent Attend Initial Consult?") {
      alert("Did Agent Attend Initial Consult? is required.");
    }else {
      setQuantNamesObj((ps) => {
        const pd = { ...ps };
        pd.standaloneBuySell = "Stand Alone Buy%2FSell Agreement";
        pd.buySellBusiness = "Buy%2FSell with Business Formation";
        return pd;
      });
      let total = cartTotal.finalPrice;
      total = total.toString();
      total = total.split(".");
      let total2 = total[0] + "00";
      total2 = total[1] ? `${total2}.${total[1]}` : total2;
      total2 = Number(total2);
      const totalToPush = cartTotal.actualValue + total2;

      //adding everything retrieved from the exisitng matter with everything purchased in this cart transaction
      const dataToPass = {
        WealthGuard:
          confirmInput.retreivedQuantities.wealthNumber +
          Number(quantities["WealthGuard"]) +
          Number(quantities["NYCWealthGuard"]) +
          Number(quantities["wealthGuardNoDeed"]) +
          Number(quantities["NYCWealthGuardNoDeed"]),
        RLTProv:
          confirmInput.retreivedQuantities.RLTSNTnumber +
          Number(quantities["RLTProv"]),
        livingSNT:
          confirmInput.retreivedQuantities.livingSNTNumber +
          Number(quantities["livingSNT"]),
        livingSNTRLT:
          confirmInput.retreivedQuantities.SNTwRLTnumber +
          Number(quantities["livingSNTRLT"]),
        LLCFormation:
          confirmInput.retreivedQuantities.LLCcorpNumber +
          Number(quantities["LLCFormation"]),
        LLCWealth:
          confirmInput.retreivedQuantities.LLCcorpwWealthNumber +
          Number(quantities["LLCWealth"]),
        IDGT:
          confirmInput.retreivedQuantities.IDGTNumber +
          Number(quantities["IDGT"]),
        MAPT:
          confirmInput.retreivedQuantities.MAPTNumber +
          Number(quantities["MAPT"]),
        DAPT:
          confirmInput.retreivedQuantities.DAPTNumber +
          Number(quantities["DAPT"]),
        CRUT:
          confirmInput.retreivedQuantities.CRUTNumber +
          Number(quantities["CRUT"]),
        LAPT:
          confirmInput.retreivedQuantities.LAPTNumber +
          Number(quantities["LAPT"]),
        CMT:
          confirmInput.retreivedQuantities.CMTNumber +
          Number(quantities["CMT"]),
        deeds:
          confirmInput.retreivedQuantities.deedNumber +
          Number(quantities["deeds"]) +
          Number(quantities["ILDeeds"]),
        assignments:
          confirmInput.retreivedQuantities.assignNumber +
          Number(quantities["assignments"]),
        notary:
          quantities["notary"] > 0 ||
          confirmInput.retreivedQuantities.isCustomNotary === true
            ? true
            : false,
        eRecording:
          confirmInput.retreivedQuantities.recordingNumber +
          Number(quantities["deeds"]) +
          Number(quantities["ILDeeds"]),
        waveFee:
          quantities["waveFee"] > 0 ||
          confirmInput.retreivedQuantities.waveFee === true
            ? true
            : false,
        deedsToBeDrafted:
          Number(confirmInput.retreivedQuantities.deedsToBeDrafted) +
          Number(quantities["deeds"]) +
          Number(quantities["WealthGuard"]) +
          Number(quantities["NYCWealthGuard"]) +
          Number(quantities["RLTProv"]) +
          Number(quantities["livingSNTRLT"]) +
          Number(quantities["ILDeeds"]),
        powerOfAttorneyI:
          Number(confirmInput.retreivedQuantities.powerOfAttorneyI) +
          Number(quantities["powerOfAttorneyI"]),
        powerOfAttorneyJ:
          Number(confirmInput.retreivedQuantities.powerOfAttorneyJ) +
          Number(quantities["powerOfAttorneyJ"]),
        corporateKit:
          Number(confirmInput.retreivedQuantities.corporateKit) +
          Number(quantities["corporateKit"]),
        familyNonOperating:
          Number(confirmInput.retreivedQuantities.familyNonOperating) +
          Number(quantities["familyNonOperating"]),
        familyOperating:
          Number(confirmInput.retreivedQuantities.familyOperating) +
          Number(quantities["familyOperating"]),
        standaloneBuySell:
          Number(confirmInput.retreivedQuantities.standaloneBuySell) +
          Number(quantities["standaloneBuySell"]),
        buySellBusiness:
          Number(confirmInput.retreivedQuantities.buySellBusiness) +
          Number(quantities["buySellBusiness"]),
        irrevocableLIT:
          Number(confirmInput.retreivedQuantities.irrevocableLITNumber) +
          Number(quantities["irrevocableLIT"]),
        bridgeTrust:
        Number(confirmInput.retreivedQuantities.bridgeTrustNumber) + //adding this (what they are buying right now) plus what they have purchased previously to update total amounts purchased
        Number(quantities["bridgeTrust"]),
        dynastyIrrevocable:
          Number(confirmInput.retreivedQuantities.dynastyIrrevocableNumber) +
          Number(quantities["dynastyIrrevocable"]),
        dynastyRevocable:
          Number(confirmInput.retreivedQuantities.dynastyRevocableNumber) +
          Number(quantities["dynastyRevocable"]),
        depositAmount: Number(quantities["designDepositQuantity"]) * 25000,
        trademarkApp:
          confirmInput.retreivedQuantities.trademarkApp +
          Number(quantities["trademarkApp"]),
        trademarkClassFee:
          confirmInput.retreivedQuantities.trademarkClassFee +
          Number(quantities["trademarkClassFee"]),
        affidavit:
          Number(confirmInput.retreivedQuantities.affidavitNumber) +
          Number(quantities["affidavit"]),
        bPetTrust:
          Number(confirmInput.retreivedQuantities.bPetTrust) +
          Number(quantities["bPetTrust"]),
        cPetTrust:
          Number(confirmInput.retreivedQuantities.cPetTrust) +
          Number(quantities["cPetTrust"]),
        wealthRestatement:
          Number(confirmInput.retreivedQuantities.wealthRestatement) +
          Number(quantities["wealthRestatement"]),
        bronzeGun:
          Number(confirmInput.retreivedQuantities.bronzeGun) +
          Number(quantities["bronzeGun"]),
        silverGun:
          Number(confirmInput.retreivedQuantities.silverGun) +
          Number(quantities["silverGun"]),
        goldGun:
          Number(confirmInput.retreivedQuantities.goldGun) +
          Number(quantities["goldGun"]),
        basicCorp:
          Number(confirmInput.retreivedQuantities.basicCorp) +
          Number(quantities["basicCorp"]),
        basicLLC:
          Number(confirmInput.retreivedQuantities.basicLLC) +
          Number(quantities["basicLLC"]),
        basicCorpWealth:
          Number(confirmInput.retreivedQuantities.basicCorpWealth) +
          Number(quantities["basicCorpWealth"]),
        basicLLCWealth:
          Number(confirmInput.retreivedQuantities.basicLLCWealth) +
          Number(quantities["basicLLCWealth"]),
        enhancedCorp:
          Number(confirmInput.retreivedQuantities.enhancedCorp) +
          Number(quantities["enhancedCorp"]),
        enhancedLLC:
          Number(confirmInput.retreivedQuantities.enhancedLLC) +
          Number(quantities["enhancedLLC"]),
        enhancedCorpWealth:
          Number(confirmInput.retreivedQuantities.enhancedCorpWealth) +
          Number(quantities["enhancedCorpWealth"]),
        enhancedLLCWealth:
          Number(confirmInput.retreivedQuantities.enhancedLLCWealth) +
          Number(quantities["enhancedLLCWealth"]),
        advancedCorp:
          Number(confirmInput.retreivedQuantities.advancedCorp) +
          Number(quantities["advancedCorp"]),
        advancedLLC:
          Number(confirmInput.retreivedQuantities.advancedLLC) +
          Number(quantities["advancedLLC"]),
        advancedCorpWealth:
          Number(confirmInput.retreivedQuantities.advancedCorpWealth) +
          Number(quantities["advancedCorpWealth"]),
        advancedLLCWealth:
          Number(confirmInput.retreivedQuantities.advancedLLCWealth) +
          Number(quantities["advancedLLCWealth"]),
        strategyReport:
          Number(confirmInput.retreivedQuantities.strategyReport) +
          Number(quantities["strategyReport"]),
        nonCrisis:
          Number(confirmInput.retreivedQuantities.nonCrisis) +
          Number(quantities["nonCrisis"]),
        crisis:
          Number(confirmInput.retreivedQuantities.crisis) +
          Number(quantities["crisis"]),
        platFunding:
          Number(confirmInput.retreivedQuantities.platFunding) +
          Number(quantities["platFunding"]),
        premFundingAst:
          Number(confirmInput.retreivedQuantities.premFundingAst) +
          Number(quantities["premFundingAst"]),
        smallEstatePkg:
          Number(confirmInput.retreivedQuantities.smallEstatePkg) +
          Number(quantities["smallEstatePkg"]),
          trustUpdate:
          Number(confirmInput.retreivedQuantities.trustUpdate) +
          Number(quantities["trustUpdate"]),
          abcFunding:
          Number(confirmInput.retreivedQuantities.abcFunding) +
          Number(quantities["abcFunding"]),
          addtlDeathAffidavit:
          Number(confirmInput.retreivedQuantities.addtlDeathAffidavit) +
          Number(quantities["addtlDeathAffidavit"]),
          addtlAccount:
          Number(confirmInput.retreivedQuantities.addtlAccount) +
          Number(quantities["addtlAccount"]),
          distrBenef:
          Number(confirmInput.retreivedQuantities.distrBenef) +
          Number(quantities["distrBenef"]),
          benef2or1:
          Number(confirmInput.retreivedQuantities.benef2or1) +
          Number(quantities["benef2or1"]),
          benefLAPT:
          Number(confirmInput.retreivedQuantities.benefLAPT) +
          Number(quantities["benefLAPT"]),
          lifetimeBenef:
          Number(confirmInput.retreivedQuantities.lifetimeBenef) +
          Number(quantities["lifetimeBenef"]),
          outrightBenef:
          Number(confirmInput.retreivedQuantities.outrightBenef) +
          Number(quantities["outrightBenef"]),
          complications:
          Number(confirmInput.retreivedQuantities.complications) +
          Number(quantities["complications"]),
          surviveSpouse:
          Number(confirmInput.retreivedQuantities.surviveSpouse) +
          Number(quantities["surviveSpouse"]),
          afterSurviveSpouse:
          Number(confirmInput.retreivedQuantities.afterSurviveSpouse) +
          Number(quantities["afterSurviveSpouse"]),
          rushFee:
          Number(confirmInput.retreivedQuantities.rushFee) +
          Number(quantities["rushFee"]),
          changeofTrustee:
          Number(confirmInput.retreivedQuantities.changeofTrustee) +
          Number(quantities["changeofTrustee"]),
          addtlProp:
          Number(confirmInput.retreivedQuantities.addtlProp) +
          Number(quantities["addtlProp"]),
          addtlRealEstate:
          Number(confirmInput.retreivedQuantities.addtlRealEstate) +
          Number(quantities["addtlRealEstate"]),

      };

      ///there's very specific wording for how to display what is purchased in the notes section of the payment window
      //these three variables and their functions basically just check what was purchased and build the appropriate string
      //so anything with "input string" is soley text formatting to look as pretty as possible
      let lawmaticsPlanAdded = decideLawmaticsPlan(dataToPass);
      let lawmaticsInputString = `${lawmaticsPlanAdded} for ${confirmInput.clientConfirm} (${confirmInput.processorConfirm}), `;
      let confidoInputString = `${confidoStringBuilder()}`;
      confidoInputString = confidoInputString.slice(0, -2);

      confidoInputString = `${confidoInputString} for ${confirmInput.clientConfirm} (${confirmInput.processorConfirm})`;
      for (const cost in dataToPass) {
        if (
          cost == "deeds" ||
          cost == "assignments" ||
          cost == "notary" ||
          cost == "eRecording" ||
          cost == "ILDeeds"
        ) {
          const quant = dataToPass[cost];
          if (quant > 0 && quant > 1) {
            lawmaticsInputString =
              lawmaticsInputString +
              `${quant} ${
                cost === "assignments"
                  ? "Assignments of Business"
                  : quantNamesObj[cost] + "s"
              }, `;
          } else if (quant === 1) {
            lawmaticsInputString =
              lawmaticsInputString + `${quantNamesObj[cost]}, `;
          } else if (quant === true) {
            lawmaticsInputString =
              lawmaticsInputString + `${quantNamesObj[cost]}, `;
          }
        }
      }
      lawmaticsInputString = lawmaticsInputString.slice(0, -2);

      if (confirmInput.processorConfirm === "No Lead Attorney Found") {
        alert("Please Add A Lead Attorney");
      }
      if (confirmInput.processorConfirm !== "No Lead Attorney Found") {
        // window.open(
        //   `https://pay.gravity-legal.com/standing-link/dadc4579-a873-4557-8531-0e6f6d6542a4?amount=${total2}&clientNotes=${confidoInputString}`
        // );
        if (confirmInput.clientId) {
          if (confirmInput.processorConfirm === "No Lead Attorney Found") {
            alert("Please Add A Lead Attorney");
          } else if (
            confirmInput.processorConfirm !== "No Lead Attorney Found"
          ) {
          }
        }
      }
      setLocationState((prevState) => {
        let pd = {
          ...prevState,
        };
        pd.notes = confidoInputString;
        pd.price = total2;

        ///copyquants is a copy of quantities that deletes everything that would NOT cause us to mark payment as true
        let copyquants = { ...quantities };
        delete copyquants["designDepositQuantity"];
        delete copyquants["deeds"];
        delete copyquants["ILDeeds"];
        delete copyquants["affidavit"];
        delete copyquants["assignments"];
        delete copyquants["notary"];
        delete copyquants["waveFee"];
        delete copyquants["customItem"];
        delete copyquants["trademarkApp"];
        delete copyquants["trademarkClassFee"];
        delete copyquants["bronzeGun"];
        delete copyquants["silverGun"];
        delete copyquants["goldGun"];
        delete copyquants["wealthRestatement"];
        delete copyquants["bPetTrust"];
        delete copyquants["cPetTrust"];
        delete copyquants["powerOfAttorneyI"];
        delete copyquants["powerOfAttorneyJ"];
        delete copyquants["platFunding"];
        delete copyquants["premFundingAst"];
        delete copyquants["strategyReport"];

        delete copyquants["smallEstatePkg"];
        delete copyquants["trustUpdate"];
        delete copyquants["abcFunding"];
        delete copyquants["addtlDeathAffidavit"];
        delete copyquants["addtlAccount"];
        delete copyquants["distrBenef"];
        delete copyquants["benef2or1"];
        delete copyquants["benefLAPT"];
        delete copyquants["lifetimeBenef"];
        delete copyquants["outrightBenef"];
        delete copyquants["complications"];

        delete copyquants["surviveSpouse"];
        delete copyquants["afterSurviveSpouse"];
        delete copyquants["rushFee"];
        delete copyquants["changeofTrustee"];
        delete copyquants["addtlProp"];
        delete copyquants["addtlRealEstate"];
          ////checks copyquants to decide if we are marking "payment received" as true and paying the agents/attornies
        const areWeMarkingPayment = Object.values(copyquants).some(
          (item) => item > 0
        );
        let isStratReport=false
        if(copyquants["strategyReport"]>0){
        delete copyquants["strategyReport"]
         isStratReport=!(Object.values(copyquants).some(
          (item) => item > 0
        ));
     
      }

      ///it being a "wealthpurchase" determines if the agent gets the baseline $400 payment for a estate plan referral
         let wealthPurchases = { ...copyquants };
        delete copyquants["corporateKit"];
        delete copyquants["basicCorp"];
        delete copyquants["basicLLC"];
        delete copyquants["basicCorpWealth"];
        delete copyquants["basicLLCWealth"];
        delete copyquants["enhancedCorp"];
        delete copyquants["enhancedLLC"];
        delete copyquants["enhancedCorpWealth"];
        delete copyquants["enhancedLLCWealth"];
        delete copyquants["advancedCorp"];
        delete copyquants["advancedLLC"];
        delete copyquants["advancedCorpWealth"];
        delete copyquants["advancedLLCWealth"];

        const isWealthPurchase = Object.values(wealthPurchases).some(
          (item) => item > 0
        );


        //create new business lets us know if we need to POST to lawmatics a new business matter
        //business value is the "actual value" of the purchased business
        let createNewBusiness = decideBusinessPlan();
        let businessValue = decideBusinessValue();

        ////push quant obj is the actual object we are pushing over to lawmatics pretty much
        //so all the data here is in its final form before the PUT operation
        pd.pushQuantObj = {
          clientId: confirmInput.clientId,
          WealthGuard: dataToPass.WealthGuard,
          RLTProv: dataToPass.RLTProv,
          livingSNT: dataToPass.livingSNT,
          livingSNTRLT: dataToPass.livingSNTRLT,
          LLCFormation: dataToPass.LLCFormation,
          LLCWealth: dataToPass.LLCWealth,
          IDGT: dataToPass.IDGT,
          MAPT: dataToPass.MAPT,
          DAPT: dataToPass.DAPT,
          CRUT: dataToPass.CRUT,
          LAPT: dataToPass.LAPT,
          CMT: dataToPass.CMT,
          deeds: dataToPass.deeds,
          assignments: dataToPass.assignments,
          notary: dataToPass.notary,
          lawmaticsInputString: lawmaticsInputString,
          totalToPush: totalToPush,
          eRecording: dataToPass.eRecording,
          waveFee: dataToPass.waveFee,
          deedsToBeDrafted: dataToPass.deedsToBeDrafted,
          powerOfAttorneyI: dataToPass.powerOfAttorneyI,
          powerOfAttorneyJ: dataToPass.powerOfAttorneyJ,
          corporateKit: dataToPass.corporateKit,
          familyNonOperating: dataToPass.familyNonOperating,
          familyOperating: dataToPass.familyOperating,
          standaloneBuySell: dataToPass.standaloneBuySell,
          buySellBusiness: dataToPass.buySellBusiness,
          irrevocableLIT: dataToPass.irrevocableLIT,
          bridgeTrust: dataToPass.bridgeTrust,
          dynastyIrrevocable: dataToPass.dynastyIrrevocable,
          dynastyRevocable: dataToPass.dynastyRevocable,
          depositAmount: dataToPass.depositAmount,
          trademarkApp: dataToPass.trademarkApp,
          trademarkClassFee: dataToPass.trademarkClassFee,
          affidavit: dataToPass.affidavit,
          bPetTrust: dataToPass.bPetTrust,
          cPetTrust: dataToPass.cPetTrust,
          wealthRestatement: dataToPass.wealthRestatement,
          bronzeGun: dataToPass.bronzeGun,
          silverGun: dataToPass.silverGun,
          goldGun: dataToPass.goldGun,
          moms25: promoCodes.used["MOMS25"] ? true : false,
          basicCorp: dataToPass.basicCorp,
          basicLLC: dataToPass.basicLLC,
          basicCorpWealth: dataToPass.basicCorpWealth,
          basicLLCWealth: dataToPass.basicLLCWealth,
          enhancedCorp: dataToPass.enhancedCorp,
          enhancedLLC: dataToPass.enhancedLLC,
          enhancedCorpWealth: dataToPass.enhancedCorpWealth,
          enhancedLLCWealth: dataToPass.enhancedLLCWealth,
          advancedCorp: dataToPass.advancedCorp,
          advancedLLC: dataToPass.advancedLLC,
          advancedCorpWealth: dataToPass.advancedCorpWealth,
          advancedLLCWealth: dataToPass.advancedLLCWealth,
          strategyReport:dataToPass.strategyReport,
    nonCrisis:dataToPass.nonCrisis,
    crisis:dataToPass.crisis,
    platFunding:dataToPass.platFunding,
    premFundingAst:dataToPass.premFundingAst,
    smallEstatePkg:dataToPass.smallEstatePkg,
    trustUpdate:dataToPass.trustUpdate,
    abcFunding:dataToPass.abcFunding,
    addtlDeathAffidavit:dataToPass.addtlDeathAffidavit,
    addtlAccount:dataToPass.addtlAccount,
    distrBenef:dataToPass.distrBenef,
    benef2or1:dataToPass.benef2or1,
    benefLAPT:dataToPass.benefLAPT,
    lifetimeBenef:dataToPass.lifetimeBenef,
    outrightBenef:dataToPass.outrightBenef,
    complications:dataToPass.complications,

    surviveSpouse:dataToPass.surviveSpouse,
    afterSurviveSpouse:dataToPass.afterSurviveSpouse,
    rushFee:dataToPass.rushFee,
    changeofTrustee:dataToPass.changeofTrustee,
    addtlProp:dataToPass.addtlProp,
    addtlRealEstate:dataToPass.addtlRealEstate,
        };
        pd.spouse = confirmInput.spouseConfirm;
        pd.fieldAgent = confirmInput.fieldAgentId;
        pd.agentFeeWaved =
          confirmInput.agentFeeWaved || dataToPass.waveFee === true
            ? true
            : false;
        pd.leadAttorneyId = confirmInput.processorConfirmId;
        pd.readyToCheckout = true;
        pd.name = confirmInput.clientConfirm;
        pd.email = couponInput.clientEmail;
        pd.areWeMarkingPayment = areWeMarkingPayment;
        pd.isWealthPurchase=isWealthPurchase
        pd.isStratReport=isStratReport
        pd.createNewBusiness = createNewBusiness.createNewBusiness;
        pd.isBusinessPurchase = createNewBusiness.isBusinessPurchase;
        pd.clientName = confirmInput.clientConfirm;
        pd.cartItems = quantities;
        pd.cartItems.cartTotal = cartTotal.finalPrice;
        pd.contactId = confirmInput.contactId;
        pd.businessValue = createNewBusiness.businessValue;
        pd.isEstatePurchase = createNewBusiness.isEstatePurchase;
        pd.clientFirstName = confirmInput.clientFirstName;
        pd.clientLastName = confirmInput.clientLastName;
        pd.phone = confirmInput.phone;
        pd.attorneyAttend=agentAttend
        pd.trustPlusToCustom=confirmInput.trustPlusToCustom
        pd.paySummitAdminFee=confirmInput.paySummitAdminFee
        return pd;
      });
    }
  };

  ///if an agent attends, they get more money, this sets the value of the corresponding state
 const onAgentAttendChanged=(e)=>{
    let value = e.target.value
 setAgentAttend((prevState)=>{
    return value
 })
}

///we sometimes have certain promo codes that have to be inputted by attornies
//this handles checking if what they put is a valid coupon, if its already been used and what discount to offer
  function applyPromoCode() {
    var couponCode = couponInput.promoCodeInput;
    var fomattedCode = couponCode.toLocaleUpperCase();
    var couponItem = promoCodes[fomattedCode];
    var couponValue = couponItem?.value;
    var couponOperator = couponItem?.operator;
    var couponRestriction = couponItem?.restriction;
    var notPreviouslyUsed = promoCodes.used[fomattedCode] ? false : true;
    let total = cartTotal.finalPrice;
    if (couponRestriction && notPreviouslyUsed) {
      setCartTotal((prevState) => {
        const pd = {
          ...prevState,
        };
        console.log(total);
        couponOperator === "add"
          ? (total = total + couponValue)
          : (total = total * couponValue);
        console.log(total);
        pd.finalPrice = total;
        pd.appliedDiscounts = couponValue;
        return pd;
      });
      setPromoCodes((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.used[fomattedCode] = true;
        return pd;
      });
      if (fomattedCode === "MOMS25") {
        alert("Coupon Code: MOMS25 applied");
      }
      if (fomattedCode === "BRIDGE10") { //newcarttotal = 
        alert("Coupon Code: BRIDGE10 applied");
      }
    } else if (!notPreviouslyUsed) {
      alert("Coupon Code Already Used");
    } else {
      alert("Invalid Coupon Code");
    }
  }

  ///they can also offer flat dollar discounts or % discounts
  //this handles those operations
  function applyCoupon() {
    var discountInput = couponInput.codeInput;

    const normalizedDiscountInput = discountInput.trim().toUpperCase();

if (normalizedDiscountInput === "BRIDGE10") {
  const bridgeQuantity = Number(quantities["bridgeTrust"] || 0);
  const bridgePrice = Number(prices["bridgeTrust"] || 0);

  if (bridgeQuantity <= 0) {
    alert("BRIDGE10 can only be used when Bridge Trust is in the cart.");
    return;
  }

  let noDiscountTotal = 0;

  for (const cost in quantities) {
    const quant = Number(quantities[cost]);
    const price = Number(prices[cost]);
    noDiscountTotal = noDiscountTotal + quant * price;
  }

  const bridgeSubtotal = bridgeQuantity * bridgePrice;
  const bridgeDiscount = bridgeSubtotal * 0.10;

  let total = noDiscountTotal - bridgeDiscount;
  total = Math.floor(total * 100) / 100;

  setCartTotal((prevState) => {
    const pd = {
      ...prevState,
    };

    pd.finalPrice = total - couponInput.depositAmount;
    pd.preDiscountPrice = noDiscountTotal;
    return pd;
  });

  setCouponInput((prevState) => {
    const pd = {
      ...prevState,
    };

    pd.pctOff = "";
    pd.dollarOff = "";
    pd.displayDiscount = bridgeDiscount.toFixed(2);
    return pd;
  });

  return;
}


    const inputLenght = discountInput.length;
    const dollarCheck = discountInput.slice(0, 1);
    const pctCheck = discountInput[inputLenght - 1];
    if (dollarCheck !== "$" && pctCheck !== "%" && !couponInput.pctOrDollar) {
      alert(`Would you like $${discountInput} off or ${discountInput}% off?`);
    }
    if (
      couponInput.pctOrDollar === "%" &&
      pctCheck !== "%" &&
      dollarCheck !== "$"
    ) {
      var discountAmount = couponInput.codeInput;
      var formattedDiscount = (100 - Number(discountAmount)) * 0.01;
      let total = 0;
      let noDiscountTotal = 0;
      for (const cost in quantities) {
        const quant = Number(quantities[cost]);
        const price = Number(prices[cost]);
        total = total + quant * price;
        noDiscountTotal = total;
      }
      total = total * formattedDiscount;
      total = Math.floor(total * 100) / 100;
      setCartTotal((prevState) => {
        const pd = {
          ...prevState,
        };

        pd.finalPrice = total - couponInput.depositAmount;
        pd.preDiscountPrice = noDiscountTotal;
        return pd;
      });
      setCouponInput((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.pctOff = discountAmount;
        pd.dollarOff = "";
        return pd;
      });
    } else if (
      couponInput.pctOrDollar === "$" &&
      pctCheck !== "%" &&
      dollarCheck !== "$"
    ) {
      var discountAmount = couponInput.codeInput;
      var formattedDiscount = Number(discountAmount);
      let total = 0;
      for (const cost in quantities) {
        const quant = Number(quantities[cost]);
        const price = Number(prices[cost]);
        total = total + quant * price;
      }
      total = total - formattedDiscount;
      total = Math.floor(total * 100) / 100;
      setCartTotal((prevState) => {
        const pd = {
          ...prevState,
        };

        pd.finalPrice = total - couponInput.depositAmount;
        return pd;
      });
      setCouponInput((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.dollarOff = discountAmount;
        pd.pctOff = "";
        return pd;
      });
    } else if (pctCheck === "%") {
      var discountAmount = discountInput.split(pctCheck)[0];
      var formattedDiscount = (100 - Number(discountAmount)) * 0.01;
      let total = 0;
      let noDiscountTotal = 0;
      for (const cost in quantities) {
        const quant = Number(quantities[cost]);
        const price = Number(prices[cost]);
        total = total + quant * price;
        noDiscountTotal = total;
      }
      total = total * formattedDiscount;
      total = Math.floor(total * 100) / 100;
      setCartTotal((prevState) => {
        const pd = {
          ...prevState,
        };

        pd.finalPrice = total - couponInput.depositAmount;
        pd.preDiscountPrice = noDiscountTotal;
        return pd;
      });
      setCouponInput((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.pctOff = discountAmount;
        pd.dollarOff = "";
        return pd;
      });
    } else if (dollarCheck === "$") {
      var discountAmount = discountInput.slice(1);
      var formattedDiscount = Number(discountAmount);
      let total = 0;
      for (const cost in quantities) {
        const quant = Number(quantities[cost]);
        const price = Number(prices[cost]);
        total = total + quant * price;
      }
      total = total - formattedDiscount;
      total = Math.floor(total * 100) / 100;
      setCartTotal((prevState) => {
        const pd = {
          ...prevState,
        };

        pd.finalPrice = total - couponInput.depositAmount;
        return pd;
      });
      setCouponInput((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.dollarOff = discountAmount;
        pd.pctOff = "";
        pd.displayDiscount = "";
        return pd;
      });
    }
  }
///once the attorney puts in the email of the client's matter in lawmatics, this checks if they exist and returns the necessary data
//this also checks if we have already created a matter for this client in EPUSA lawmatics, and if so, grabs that related data
  function confirmClicked(e) {
    // if(couponInput.clientEmail=="")
    // {
    //    alert("Please enter client's email (as it appears in the client's matter)")
    // }
    // else
    // if(couponInput.clientEmail.match(isValidEmail)){
    e.preventDefault();
    let clientEmail = couponInput.clientEmail;
    if (isExistingBusiness.exists === false) {
      lawService
        .getMatterByEmail(clientEmail)
        .then((r) => {
          onGetMatterSuccess(r);
        })
        .catch(() => {
          onGetMatterFail();
        });
      lawService
        .getEPUSAMatterByEmail(clientEmail)
        .then((r) => {
          const epusaMatterId = r.data.data.id;
          const epusaContactId = r.data.data.relationships.contact.data.id;
          setLocationState((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.isEPUSA = epusaMatterId;
            updatedFormData.epusaContactId = epusaContactId;
            return updatedFormData;
          });
        })
        .catch((e) => {
          setLocationState((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.isEPUSA = false;

            return updatedFormData;
          });
        });
    } else {
      setLoading((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.loading = true;

            return updatedFormData;
          });
      let ignCompanyMatterId = 0;
      lawService
        .findCompanyContact(clientEmail, "ign")
        .then((r) => {
          const matterId = r.data.data.relationships.prospects.data[0].id;
          ignCompanyMatterId = matterId;
          setLocationState((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.ignCompanyMatterId = ignCompanyMatterId;
            return updatedFormData;
          });
          lawService
            .getMatterById(matterId)
            .then((r) => {
              onGetMatterSuccess(r);
              setLoading((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.loading = false;

            return updatedFormData;
          });
            })
            .catch(() => {
              onGetMatterFail();
              setLoading((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.loading = false;

            return updatedFormData;
          });
            });
        })
        .catch(() => {
          onGetMatterFail();
          setLoading((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.loading = false;

            return updatedFormData;
          });
        });
      lawService
        .findCompanyContact(clientEmail, "epusa")
        .then((r) => {
          const epusaCompanyMatterId =
            r.data.data.relationships.prospects.data[0].id;
          setLocationState((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.epusaCompanyMatterId = epusaCompanyMatterId;
            updatedFormData.ignCompanyMatterId = ignCompanyMatterId;
            return updatedFormData;
          });
        })
        .catch((e) => {
          setLocationState((prevState) => {
            const updatedFormData = {
              ...prevState,
            };
            updatedFormData.epusaCompanyMatterId = false;
            updatedFormData.ignCompanyMatterId = ignCompanyMatterId;
            return updatedFormData;
          });
        });
    }
  }

  ///if the email does correspond to an existing matter, this formats that data from the response
  ///from the lamatics API
  const onGetMatterSuccess = async (r) => {
    const id = r.data.data.id;
    const attorneyId = r.data.data.relationships.lead_attorney.data?.id;
    const clientName = r.data.data.attributes.name;
    const clientFirstName = r.data.data.attributes.first_name;
    const clientLastName = r.data.data.attributes.last_name;
    const phone = r.data.data.attributes.phone;
    const contactId = r.data.data.relationships.contact?.data.id;
    const tags=r.data.data.relationships.tags?.data;
    let trustPlusToCustom=false
    let paySummitAdminFee=false
    for (let i = 0; i < tags.length; i++) {
      const currentTag = tags[i];
      if(currentTag.id==="130627")
      {
        trustPlusToCustom=true
        break
      }
      if(currentTag.id==="136438")
      {
        paySummitAdminFee=true

      }
    }
    let attorneyAttend=false
    
    let spouseName = 0;
    let fieldAgentId = 0;
    let agentFeeWaved = false;
    let retreivedData = {
      wealthNumber: 0,
      RLTSNTnumber: 0,
      livingSNTNumber: 0,
      SNTwRLTnumber: 0,
      LLCcorpNumber: 0,
      LLCcorpwWealthNumber: 0,
      IDGTNumber: 0,
      MAPTNumber: 0,
      DAPTNumber: 0,
      CRUTNumber: 0,
      LAPTNumber: 0,
      CMTNumber: 0,
      deedNumber: 0,
      assignNumber: 0,
      isFeeWaved: false,
      deedsToBeDrafted: 0,
      powerOfAttorneyI: 0,
      powerOfAttorneyJ: 0,
      corporateKit: 0,
      familyOperating: 0,
      familyNonOperating: 0,
      standaloneBuySell: 0,
      buySellBusiness: 0,
      irrevocableLITNumber: 0,
      bridgeTrust: 0,
      dynastyIrrevocableNumber: 0,
      dynastyRevocableNumber: 0,
      designDepositQuantity: 0,
      depositAmount: 0,
      trademarkApp: 0,
      trademarkClassFee: 0,
      affidavitNumber: 0,
      bPetTrust: 0,
      cPetTrust: 0,
      wealthRestatement: 0,
      goldGun: 0,
      silverGun: 0,
      bronzeGun: 0,
      basicCorp: 0,
      basicLLC: 0,
      basicCorpWealth: 0,
      basicLLCWealth: 0,
      enhancedCorp: 0,
      enhancedLLC: 0,
      enhancedCorpWealth: 0,
      enhancedLLCWealth: 0,
      advancedCorp: 0,
      advancedLLC: 0,
      advancedCorpWealth: 0,
      advancedLLCWealth: 0,
      strategyReport:0,
    nonCrisis:0,
    crisis:0,
    platFunding:0,
    premFundingAst:0,
    smallEstatePkg:0,
    trustUpdate:0,
    abcFunding:0,
    addtlDeathAffidavit:0,
    addtlAccount:0,
    distrBenef:0,
    benef2or1:0,
    benefLAPT:0,
    lifetimeBenef:0,
    outrightBenef:0,
    complications:0,

    surviveSpouse:0,
    afterSurviveSpouse:0,
    rushFee:0,
    changeofTrustee:0,
    addtlProp:0,
    addtlRealEstate:0
    };

    const attorneyName = attorneyId
      ? await lawService.getAttorneyById(attorneyId)
      : "No Lead Attorney Found";
    const custom_fields = r.data.data.attributes.custom_fields;
    ///the custom fields are just give to us in an array
    //we sort through them and determine which value goes into the corresponding object
    //custom fields are where we store data on what they've purchase, among other things
    for (let i = 0; i < custom_fields.length; i++) {
      const element = custom_fields[i];
      if (element.id === "447001") {
        retreivedData.deedNumber = element.value;
      }
      if (element.id === "467402") {
        retreivedData.assignNumber = element.value;
      }
      if (element.id === "478675") {
        retreivedData.wealthNumber = element.value;
      }
      if (element.id === "480990") {
        retreivedData.RLTSNTnumber = element.value;
      }
      if (element.id === "480991") {
        retreivedData.livingSNTNumber = element.value;
      }
      if (element.id === "480992") {
        retreivedData.SNTwRLTnumber = element.value;
      }
      if (element.id === "480994") {
        retreivedData.LLCcorpNumber = element.value;
      }
      if (element.id === "480995") {
        retreivedData.LLCcorpwWealthNumber = element.value;
      }
      if (element.id === "480996") {
        retreivedData.IDGTNumber = element.value;
      }
      if (element.id === "480997") {
        retreivedData.MAPTNumber = element.value;
      }
      if (element.id === "480998") {
        retreivedData.DAPTNumber = element.value;
      }
      if (element.id === "480999") {
        retreivedData.CRUTNumber = element.value;
      }
      if (element.id === "481388") {
        retreivedData.LAPTNumber = element.value;
      }
      if (element.id === "481389") {
        retreivedData.CMTNumber = element.value;
      }
      if (element.id === "481387") {
        retreivedData.isCustomNotary = element.value;
      }
      if (element.id === "482996") {
        retreivedData.recordingNumber = element.value;
      }
      if (element.id === "483085") {
        retreivedData.waveFee = element.value;
      }
      if (element.id === "495641") {
        retreivedData.deedsToBeDrafted = element.value;
      }
      if (element.id === "515411") {
        retreivedData.powerOfAttorneyJ = element.value;
      }
      if (element.id === "515410") {
        retreivedData.powerOfAttorneyI = element.value;
      }
      if (element.id === "519736") {
        retreivedData.corporateKit = element.value;
      }
      if (element.id === "523619") {
        retreivedData.familyNonOperating = element.value;
      }
      if (element.id === "523618") {
        retreivedData.familyOperating = element.value;
      }
      if (element.id === "539285") {
        retreivedData.standaloneBuySell = element.value;
      }
      if (element.id === "539286") {
        retreivedData.buySellBusiness = element.value;
      }
      if (element.id === "539287") {
        retreivedData.irrevocableLITNumber = element.value;
      }
      if (element.id === "552648") {
        retreivedData.dynastyRevocableNumber = element.value;
      }
      if (element.id === "877235") {
        retreivedData.bridgeTrustNumber = element.value;//check everything they have bought in the past
      }
      if (element.id === "552647") {
        retreivedData.dynastyIrrevocableNumber = element.value;
      }

      if (element.id === "563798") {
        retreivedData.depositAmount = element.value;
      }
      if (element.id === "421736") {
        spouseName = element.value;
      }
      if (element.id === "564570") {
        retreivedData.trademarkApp = element.value;
      }
      if (element.id === "565097") {
        retreivedData.trademarkClassFee = element.value;
      }
      if (element.id === "588664") {
        retreivedData.bPetTrust = element.value;
      }
      if (element.id === "588665") {
        retreivedData.cPetTrust = element.value;
      }
      if (element.id === "573951") {
        retreivedData.affidavitNumber = element.value;
      }
      if (element.id === "588663") {
        retreivedData.wealthRestatement = element.value;
      }
      if (element.id === "588660") {
        retreivedData.bronzeGun = element.value;
      }
      if (element.id === "588661") {
        retreivedData.silverGun = element.value;
      }
      if (element.id === "588662") {
        retreivedData.goldGun = element.value;
      }
      if (element.id === "422722") {
        fieldAgentId = element.value;
      }
      if (element.id === "483085") {
        agentFeeWaved = element.value;
      }
      if (element.id === "609000") {
        retreivedData.basicCorp = element.value;
      }
      if (element.id === "608998") {
        retreivedData.basicLLC = element.value;
      }
      if (element.id === "609023") {
        retreivedData.basicCorpWealth = element.value;
      }
      if (element.id === "609028") {
        retreivedData.basicLLCWealth = element.value;
      }
      if (element.id === "609029") {
        retreivedData.enhancedCorpWealth = element.value;
      }
      if (element.id === "609030") {
        retreivedData.enhancedLLCWealth = element.value;
      }
      if (element.id === "609031") {
        retreivedData.enhancedCorp = element.value;
      }
      if (element.id === "609027") {
        retreivedData.enhancedLLC = element.value;
      }
      if (element.id === "609033") {
        retreivedData.advancedCorp = element.value;
      }
      if (element.id === "609032") {
        retreivedData.advancedLLC = element.value;
      }
      if (element.id === "609034") {
        retreivedData.advancedCorpWealth = element.value;
      }
      if (element.id === "609035") {
        retreivedData.advancedLLCWealth = element.value;
      }
      if (element.id === "699980") {
        retreivedData.strategyReport = element.value;
      }
      if (element.id === "699981") {
        retreivedData.nonCrisis = element.value;
      }
      if (element.id === "699982") {
        retreivedData.crisis = element.value;
      }
      // if (element.id === "705820") {
      //   attorneyAttend = element.value;
      // }
      if (element.id === "713699") {
         retreivedData.platFunding = element.value;
      }
      if (element.id === "713700") {
         retreivedData.premFundingAst = element.value;
      }
      //
       if (element.id === "729989") {
         retreivedData.smallEstatePkg = element.value;
      }
       if (element.id === "729992") {
         retreivedData.trustUpdate = element.value;
      }
       if (element.id === "729994") {
         retreivedData.abcFunding = element.value;
      }
       if (element.id === "729996") {
         retreivedData.addtlDeathAffidavit = element.value;
      }
       if (element.id === "729999") {
         retreivedData.addtlAccount = element.value;
      }
       if (element.id === "730000") {
         retreivedData.distrBenef = element.value;
      }
       if (element.id === "730002") {
         retreivedData.benef2or1 = element.value;
      }
       if (element.id === "730003") {
         retreivedData.benefLAPT = element.value;
      }
       if (element.id === "730004") {
         retreivedData.lifetimeBenef = element.value;
      }
       if (element.id === "730005") {
         retreivedData.outrightBenef = element.value;
      }
      if (element.id === "730006") {
         retreivedData.complications = element.value;
      }

      if (element.id === "733701") {
         retreivedData.surviveSpouse = element.value;
      }
      if (element.id === "733702") {
         retreivedData.afterSurviveSpouse = element.value;
      }
      if (element.id === "733703") {
         retreivedData.rushFee = element.value;
      }
      if (element.id === "733704") {
         retreivedData.changeofTrustee = element.value;
      }

      if (element.id === "733782") {
         retreivedData.addtlProp = element.value;
      }
      if (element.id === "733783") {
         retreivedData.addtlRealEstate = element.value;
      }
    }

    ///fetched value is how much money they've already paid us
    //we will add this purchased to that
    let fetchedValue = r.data.data.attributes.actual_value_cents;
    setCartTotal((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.actualValue = fetchedValue;
      return pd;
    });
    if (retreivedData.depositAmount > 0) {
      setCouponInput((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.depositAmount = retreivedData.depositAmount / 100;
        return pd;
      });
      // var discountAmount = retreivedData.depositAmount/100;
      // var formattedDiscount = Number(discountAmount);
      // let total = 0;
      // for (const cost in quantities) {
      //   const quant = Number(quantities[cost]);
      //   const price = Number(prices[cost]);
      //   total = total + quant * price;
      // }
      // total = total - formattedDiscount;
      // total = Math.floor(total * 100) / 100;
      // setCartTotal((prevState) => {
      //   const pd = {
      //     ...prevState,
      //   };

      //   pd.finalPrice = total;
      //   return pd;
      // });
    }

    ///sets state with info that we just gathered and sorted through
    setConfirmInput((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData["clientConfirm"] = clientName;
      updatedFormData["processorConfirm"] = attorneyName;
      updatedFormData.searchedClient = true;
      updatedFormData.clientId = id;
      updatedFormData.processorConfirmId = attorneyId ? attorneyId : null;
      updatedFormData.retreivedQuantities = retreivedData;
      updatedFormData.spouseConfirm = spouseName;
      updatedFormData.fieldAgentId = fieldAgentId;
      updatedFormData.agentFeeWaved = agentFeeWaved;
      updatedFormData.contactId = contactId;
      updatedFormData.clientFirstName = clientFirstName;
      updatedFormData.clientLastName = clientLastName;
      updatedFormData.phone = phone;
      updatedFormData.attorneyAttend=agentAttend
      updatedFormData.trustPlusToCustom=trustPlusToCustom
      updatedFormData.paySummitAdminFee=paySummitAdminFee
      return updatedFormData;
    });
  };
  const onGetMatterFail = () => {
    setConfirmInput((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData.searchedClient = true;
      updatedFormData["processorConfirm"] = "No Lead Attorney Found";
      updatedFormData["clientConfirm"] = "";
      updatedFormData.clientId = null;
      updatedFormData.processorConfirmId = null;
      return updatedFormData;
    });
    alert(
      "No client found with that email. Please ensure email is correct or enter\nclient information manually below."
    );
  };
///all these stringbuilders and decide plan functions pretty much only exist to format strings to look good
///they don't really do anything functional beyond that
  function confidoStringBuilder() {
    let confidoInputString = decidePlan();
    for (const cost in quantities) {
      if (
        cost == "deeds" ||
        cost == "assignments" ||
        cost == "notary" ||
        cost === "ILDeeds"
      ) {
        const quant = Number(quantities[cost]);
        if (quant > 0 && quant > 1) {
          confidoInputString =
            confidoInputString +
            `${quant} ${
              cost === "assignments"
                ? "Assignments of Business"
                : quantNamesObj[cost] + "s"
            }, `;
        } else if (quant === 1) {
          confidoInputString = confidoInputString + `${quantNamesObj[cost]}, `;
        }
      } else if (cost == "eRecording") {
        const quant =
          Number(quantities["deeds"]) + Number(quantities["ILDeeds"]);
        if (quant > 0 && quant > 1) {
          confidoInputString =
            confidoInputString +
            `${quant} ${
              cost === "assignments"
                ? "Assignments of Business"
                : "Electronic Recording" + "s"
            }, `;
        } else if (quant === 1) {
          confidoInputString = confidoInputString + `Electronic Recording, `;
        }
      }
    }
    return confidoInputString;
  }

  function decidePlan() {
    let planAdded = "";
    let cmtString = "Credit Maximization Trust";
    let laptString = "Lifetime Trust";
    let cmtOrLapt = quantities["CMT"] > 0 || quantities["LAPT"] > 0 ? "-" : "";
    let cmtAndLapt =
      quantities["CMT"] > 0 && quantities["LAPT"] > 0 ? " and " : "";
    for (const cost in quantities) {
      if (
        cost !== "deeds" &&
        cost !== "ILDeeds" &&
        cost !== "assignments" &&
        cost !== "notary" &&
        cost !== "eRecording" &&
        cost !== "waveFee" &&
        cost !== "LAPT" &&
        cost !== "CMT"
      ) {
        const amount = Number(quantities[cost]);
        if (
          cost === "WealthGuard" ||
          cost === "NYCWealthGuard" ||
          cost === "NYCWealthGuardNoDeed" ||
          cost === "wealthGuardNoDeed"
        ) {
          if (amount > 0 && amount > 1) {
            planAdded = `${planAdded} ${amount} ${
              quantNamesObj[cost]
            }s${cmtOrLapt}${
              quantities["CMT"] > 0 ? cmtString : ""
            } ${cmtAndLapt} ${quantities["LAPT"] > 0 ? laptString : ""}; `;
          } else if (amount === 1) {
            planAdded = `${planAdded} ${quantNamesObj[cost]} ${cmtOrLapt}${
              quantities["CMT"] > 0 ? cmtString : ""
            }${cmtAndLapt}${quantities["LAPT"] > 0 ? laptString : ""}; `;
          }
        } else if (cost === "LLCFormation" || cost === "LLCWealth") {
          if (amount > 0 && amount > 1) {
            if (shopItems.llcOrCorp.noWealth == "llc") {
              planAdded = `${planAdded} Formation of ${amount} LLC's; `;
            } else {
              planAdded = `${planAdded} Formation of ${amount} Corporations; `;
            }
          } else if (amount === 1) {
            if (shopItems.llcOrCorp.noWealth == "llc") {
              planAdded = `${planAdded} Formation of LLC; `;
            } else {
              planAdded = `${planAdded} Formation of Corporation; `;
            }
          }
        } else if (amount > 1 && cost === "powerOfAttorneyJ") {
          if (cost === "powerOfAttorneyJ") {
            planAdded = `${planAdded} ${amount} Power of Attorney Packages - Joint; `;
          }
        } else if (amount > 1 && cost === "powerOfAttorneyI") {
          if (cost === "powerOfAttorneyI") {
            planAdded = `${planAdded} ${amount} Power of Attorney Packages - Individual; `;
          }
        } else if (amount > 1 && cost === "familyNonOperating") {
          if (cost === "familyNonOperating") {
            planAdded = `${planAdded} ${amount} Private Family Foundations Non-Operating; `;
          }
        } else if (amount > 1 && cost === "familyOperating") {
          if (cost === "familyOperating") {
            planAdded = `${planAdded} ${amount} Private Family Foundations Operating; `;
          }
        } else if (amount > 1 && cost === "affidavit") {
          if (cost === "affidavit") {
            planAdded = `${planAdded} ${amount} Affidavits of Death of Joint Tenant; `;
          }
        } else if (amount > 0 && amount > 1) {
          planAdded = `${planAdded} ${amount} ${quantNamesObj[cost]}s; `;
        } else if (amount === 1) {
          planAdded = `${planAdded} ${quantNamesObj[cost]}; `;
        }
      }
    }
    // planAdded = planAdded.slice(0, -2);
    return planAdded;
  }

  function decideLawmaticsPlan(obj) {
    let planAdded = "";
    let cmtString = "Credit Maximization Trust";
    let laptString = "Lifetime Trust";
    let cmtOrLapt = obj["CMT"] > 0 || obj["LAPT"] > 0 ? "-" : "";
    let cmtAndLapt = obj["CMT"] > 0 && obj["LAPT"] > 0 ? "and" : "";
    for (let cost in obj) {
      if (
        cost !== "deeds" &&
        cost !== "ILDeeds" &&
        cost !== "assignments" &&
        cost !== "notary" &&
        cost !== "eRecording" &&
        cost !== "waveFee" &&
        cost !== "LAPT" &&
        cost !== "CMT" &&
        cost !== "deedsToBeDrafted" &&
        cost !== "depositAmount"
      ) {
        //  {
        //   const amount = Number(obj[cost]);
        //   if (amount > 0 && amount > 1) {
        //     planAdded = `${planAdded} ${amount} ${quantNamesObj[cost]}s; `;
        //   } else if (amount === 1) {
        //     planAdded = `${planAdded} ${quantNamesObj[cost]}; `;
        //   }
        // }
        const amount = Number(obj[cost]);
        if (cost === "buySellBusiness") {
          cost = "buySellBusinessFormatted";
        }
        if (cost === "standaloneBuySell") {
          cost = "standaloneBuySellFormatted";
        }
        if (
          cost === "WealthGuard" ||
          cost === "NYCWealthGuard" ||
          cost === "NYCWealthGuardNoDeed" ||
          cost === "wealthGuardNoDeed"
        ) {
          if (amount > 0 && amount > 1) {
            planAdded = `${planAdded} ${amount} ${
              quantNamesObj[cost]
            }s ${cmtOrLapt} ${obj["CMT"] > 0 ? cmtString : ""} ${cmtAndLapt} ${
              obj["LAPT"] > 0 ? laptString : ""
            }; `;
          } else if (amount === 1) {
            planAdded = `${planAdded} ${quantNamesObj[cost]} ${cmtOrLapt} ${
              obj["CMT"] > 0 ? cmtString : ""
            } ${cmtAndLapt} ${obj["LAPT"] > 0 ? laptString : ""}; `;
          }
        } else if (cost === "LLCFormation" || cost === "LLCWealth") {
          if (amount > 0 && amount > 1) {
            planAdded = `${planAdded} Formation of ${amount} LLC's; `;
          } else if (amount === 1) {
            planAdded = `${planAdded} Formation of LLC; `;
          }
        } else if (amount > 1 && cost === "powerOfAttorneyJ") {
          if (cost === "powerOfAttorneyJ") {
            planAdded = `${planAdded} ${amount} Power of Attorney Packages - Joint; `;
          }
        } else if (amount > 1 && cost === "powerOfAttorneyI") {
          if (cost === "powerOfAttorneyI") {
            planAdded = `${planAdded} ${amount} Power of Attorney Packages - Individual; `;
          }
        } else if (amount > 1 && cost === "familyOperating") {
          if (cost === "familyOperating") {
            planAdded = `${planAdded} ${amount} Private Family Foundations Operating; `;
          }
        } else if (amount > 1 && cost === "familyNonOperating") {
          if (cost === "familyNonOperating") {
            planAdded = `${planAdded} ${amount} Private Family Foundations Non-Operating; `;
          }
        } else if (amount > 1 && cost === "affidavit") {
          if (cost === "affidavit") {
            planAdded = `${planAdded} ${amount} Affidavits of Death of Joint Tenant; `;
          }
        } else if (amount > 0 && amount > 1) {
          planAdded = `${planAdded} ${amount} ${quantNamesObj[cost]}s; `;
        } else if (amount === 1) {
          planAdded = `${planAdded} ${quantNamesObj[cost]}; `;
        }
      }
    }
    // planAdded = planAdded.slice(0, -2);
    return planAdded;
  }
  const decideTypeDiscount = (e) => {
    setCouponInput((prevState) => {
      let pd = {
        ...prevState,
      };
      pd.pctOrDollar = e.target.id;
      return pd;
    });
  };

  ///there's an option to add a custom item in the shopping cart and name and price it yourself
  //this handles making sure all that info can come over
  const onCustomItemChanged = (e) => {
    const target = e.target;
    let value = target.value;
    const name = target.name;
    setPrices((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      return updatedFormData;
    });
  };
  const onCustomItemNamedChanged = (e) => {
    const target = e.target;
    let value = target.value;
    const name = target.name;
    setShopItems((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      for (let i = 0; i < updatedFormData.generalEstate.length; i++) {
        const currentShopItem = updatedFormData.generalEstate[i];
        if (currentShopItem.name === name) {
          currentShopItem.title = value;
        }
      }
      return updatedFormData;
    });
    setQuantNamesObj((prevState) => {
      const pd = {
        ...prevState,
      };
      pd["customItem"] = value;
      return pd;
    });
  };

  return (
   <div id="big-div" style={{ "padding-left": "150px !important" }}>
 {/* <div style={{ "padding-left": "250px" }}>  */}
      <div class="container2">
        <section class="container2 content-section">
          <div
            className="d-flex justify-content-between"
            //onClick={toggle}
            opener="general"
          >
            <h2 className="section-header " onClick={toggle} opener="general">
              General Estate Planning{" "}
            </h2>
            {!isOpen.general && (
              <BsCaretUp
                className="mt-3"
                size={"2.5em"}
                onClick={toggle}
                opener="general"
              />
            )}
            {isOpen.general && (
              <BsCaretDown
                className="mt-3"
                size={"2.5em"}
                onClick={toggle}
                opener="general"
              />
            )}
          </div>
          <hr />
          <Collapse isOpen={isOpen.general}>


            {shopItems.generalEstate.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                    {item.extras2?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras2?.title}</span>
                          <span class="shop-item-price">
                            {item.extras2?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras2?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
            ))}
            <div class="shop-item" key={"558547"}>
              <div class="shop-item-details">
                <span
                  style={{
                    display: "grid",
                    width: "100%",
                    "text-align": "left",
                    "font-weight": "bold",
                    "font-size": "1.5em",
                    color: "#333",
                    " margin-bottom": "15px",
                    "margin-right": "0px",
                  }}
                >
                  <div class="b" style={{ width: "75%" }}>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Custom Item"
                      id="customItemLabel"
                      name="customItem"
                      onChange={onCustomItemNamedChanged}
                      style={{ "font-size": "1.5rem" }}
                    ></input>
                    {/* <label for="customItemLabel" style={{"font-size": `${document.activeElement === document.getElementById('customItemLabel')?"1rem":"1.5rem"}`}}>Custom Purchase</label> */}
                  </div>
                </span>
                <span class="shop-item-price" style={{ "margin-top": "25px" }}>
                  <div
                    class="input-group "
                    style={{
                      width: "50%",
                      "margin-left": "25%",
                      height: "40px",
                    }}
                  >
                    <span class="input-group-text" style={{ height: "40px" }}>
                      $
                    </span>
                    <input
                      type="number"
                      class="form-control"
                      name="customItem"
                      aria-label="Amount (to the nearest dollar)"
                      onChange={onCustomItemChanged}
                      style={{
                        "font-size": "1rem",
                        height: "40px",
                        "box-shadow": "none !important",
                      }}
                    />
                  </div>
                </span>
                <button
                  class="btn2 btn-primary shop-item-button"
                  name={"customItem"}
                  type="button"
                  onClick={addToCartClicked}
                  style={{ "margin-top": "1%" }}
                >
                  ADD TO CART
                </button>
              </div>
            </div>
          </Collapse>
          <div
            className="d-flex justify-content-between"
            //onClick={toggle}
            opener="advanced"
          >
            <h2 class="section-header" onClick={toggle} opener="advanced">
              Advanced Estate Planning
            </h2>
            {!isOpen.advanced && (
              <BsCaretUp
                size={"2.5em"}
                className="mt-3"
                onClick={toggle}
                opener="advanced"
              />
            )}
            {isOpen.advanced && (
              <BsCaretDown
                size={"2.5em"}
                className="mt-3"
                onClick={toggle}
                opener="advanced"
              />
            )}
          </div>
          <hr />
          <Collapse isOpen={isOpen.advanced}>
            {shopItems.advancedEstate.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}</span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
            ))}
          </Collapse>
            <div
            className="d-flex justify-content-between"
            //onClick={toggle}
            opener="medicaid"
          >
            <h2 class="section-header" onClick={toggle} opener="medicaid">
              Medicaid Planning
            </h2>
            {!isOpen.medicaid && (
              <BsCaretUp
                size={"2.5em"}
                className="mt-3"
                onClick={toggle}
                opener="medicaid"
              />
            )}
            {isOpen.medicaid && (
              <BsCaretDown
                size={"2.5em"}
                className="mt-3"
                onClick={toggle}
                opener="medicaid"
              />
            )}
          </div>
          <hr />
          <Collapse isOpen={isOpen.medicaid}>
            {shopItems.medicaidPlanning.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}</span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
            ))}
          </Collapse>
          <div
            className="d-flex justify-content-between"
            id="business"
            // onClick={toggle}
          >
            <h2 class="section-header" onClick={toggle} opener="business">
              Business Planning
            </h2>
            {isOpen.business && (
              <BsCaretDown
                size={"2.5em"}
                className="mt-3"
                opener="business"
                onClick={toggle}
              />
            )}
            {!isOpen.business && (
              <BsCaretUp
                size={"2.5em"}
                className="mt-3"
                opener="business"
                onClick={toggle}
              />
            )}
          </div>
            
          <hr />
          <Collapse isOpen={isOpen.business}>
            {shopItems.businessPlanning.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}</span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
            ))}
          </Collapse>
             <div
            className="d-flex justify-content-between"
            //onClick={toggle}
            opener="trustAdmin"
          >
            <h2 class="section-header" onClick={toggle} opener="trustAdmin">
              Trust Administration/Termination
            </h2>
            {!isOpen.trustAdmin && (
              <BsCaretUp
                size={"2.5em"}
                className="mt-3"
                onClick={toggle}
                opener="trustAdmin"
              />
            )}
            {isOpen.trustAdmin && (
              <BsCaretDown
                size={"2.5em"}
                className="mt-3"
                onClick={toggle}
                opener="trustAdmin"
              />
            )}
          </div>
          <hr />
          <Collapse isOpen={isOpen.trustAdmin}>
          
          <h3>1st Death</h3>
            {shopItems.trustAdmin.items.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
              
            ))}
            <h4>Add Ons:</h4>
            {shopItems.trustAdmin.addOns1.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
              
            ))}
            <h3>2nd Death</h3>
            {shopItems.trustAdmin.items2.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
              
            ))}
            <h4>Add Ons:</h4>
            {shopItems.trustAdmin.addOns2.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
              
            ))}
            <h3>Incapacity Trustee Step-In Package</h3>
            {shopItems.trustAdmin.stepIn.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
              
            ))}
            <h4>Add Ons:</h4>
            {shopItems.trustAdmin.addOns3.map((item, index) => (
              <div class="shop-item" key={index}>
                {item.display && (
                  <>
                    <div class="shop-item-details">
                      <span class="shop-item-title2">{item.title}<span className="small">{item.disclaimer}</span></span>
                      <span class="shop-item-price">{item.price}</span>
                      <button
                        class="btn2 btn-primary shop-item-button"
                        name={item.name}
                        type="button"
                        onClick={addToCartClicked}
                      >
                        ADD TO CART
                      </button>
                    </div>
                    <div>
                      {item.displayFilingFeeNote === true && (
                        <div style={{ "font-size": "15px" }}>
                          Up to $200 included for state filing fees
                        </div>
                      )}
                    </div>
                    {item.extras?.display === true &&
                      quantities[item.name] > 0 && (
                        <div class="shop-item-details">
                          <span class="extra-title">{item.extras?.title}</span>
                          <span class="shop-item-price">
                            {item.extras?.price}
                          </span>
                          <button
                            class="btn2 btn-primary shop-item-button"
                            name={item.extras?.name}
                            type="button"
                            onClick={addToCartClicked}
                            style={{ "padding-right": "40px" }}
                          >
                            ADD TO CART
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
              
            ))}
          </Collapse>
          <h2 class="section-header">Additional Options:</h2>
          <hr />
          
          {shopItems.options.map((item, index) => (
            <div class="shop-item" key={index + 100}>
              <div class="shop-item-details">
                <span class="shop-item-title2">
                  {item.title}
                  <span className="small">{item.disclaimer}</span>
                </span>
                <span class="shop-item-price priceBox">{item.price}</span>
                <button
                  class="btn2 btn-primary shop-item-button"
                  name={item.name}
                  type="button"
                  onClick={addToCartClicked}
                >
                  ADD TO CART
                </button>
              </div>
            </div>
          ))}
        </section>
        <section class="container2 content-section">
          <h2 class="section-header">CART</h2>
          <div class="cart-row">
            <span class="cart-item cart-header cart-column">ITEM</span>
            <span class="cart-price cart-header cart-column">PRICE</span>
            <span class="cart-quantity cart-header cart-column">QUANTITY</span>
          </div>
          {shopItems.generalEstate.map((item, index) => (
            <div class="cart-items" key={index + 200}>
              {quantities[item.name] > 0 && (
                <>
                  <div class="cart-row">
                    <div class="cart-item cart-column">
                      <span class="cart-item-title">{item.title}</span>
                    </div>
                    <span class="cart-price cart-column">
                      ${Number(prices[item.name]).toLocaleString()}
                    </span>
                    <div class="cart-quantity cart-column">
                      <input
                        class="cart-quantity-input"
                        type="number"
                        name={item.name}
                        value={quantities[item.name]}
                        onChange={onFormFieldChange}
                      />
                      <button
                        class="btn2 btn-danger"
                        type="button"
                        name={item.name}
                        onClick={removeCartItem}
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
          {shopItems.advancedEstate.map((item, index) => (
            <div class="cart-items" key={index + 200}>
              {quantities[item.name] > 0 && (
                <>
                  <div class="cart-row">
                    <div class="cart-item cart-column">
                      <span class="cart-item-title">{item.title}</span>
                    </div>
                    <span class="cart-price cart-column">
                      ${Number(prices[item.name]).toLocaleString()}
                    </span>
                    <div class="cart-quantity cart-column">
                      <input
                        class="cart-quantity-input"
                        type="number"
                        name={item.name}
                        value={quantities[item.name]}
                        onChange={onFormFieldChange}
                      />
                      <button
                        class="btn2 btn-danger"
                        type="button"
                        name={item.name}
                        onClick={removeCartItem}
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
          {shopItems.medicaidPlanning.map((item, index) => (
            <div class="cart-items" key={index + 200}>
              {quantities[item.name] > 0 && (
                <>
                  <div class="cart-row">
                    <div class="cart-item cart-column">
                      <span class="cart-item-title">{item.title}</span>
                    </div>
                    <span class="cart-price cart-column">
                      ${Number(prices[item.name]).toLocaleString()}
                    </span>
                    <div class="cart-quantity cart-column">
                      <input
                        class="cart-quantity-input"
                        type="number"
                        name={item.name}
                        value={quantities[item.name]}
                        onChange={onFormFieldChange}
                      />
                      <button
                        class="btn2 btn-danger"
                        type="button"
                        name={item.name}
                        onClick={removeCartItem}
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
          {shopItems.businessPlanning.map((item, index) => (
            <div class="cart-items" key={index + 200}>
              {quantities[item.name] > 0 && (
                <>
                  <div class="cart-row">
                    <div class="cart-item cart-column">
                      <span class="cart-item-title">{item.title}</span>
                    </div>
                    <span class="cart-price cart-column">
                      ${Number(prices[item.name]).toLocaleString()}
                    </span>
                    <div class="cart-quantity cart-column">
                      <input
                        class="cart-quantity-input"
                        type="number"
                        name={item.name}
                        value={quantities[item.name]}
                        onChange={onFormFieldChange}
                      />
                      <button
                        class="btn2 btn-danger"
                        type="button"
                        name={item.name}
                        onClick={removeCartItem}
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
          {shopItems.trustAdmin.items.map((item, index) => (
            <div class="cart-items" key={index + 200}>
              {quantities[item.name] > 0 && (
                <>
                  <div class="cart-row">
                    <div class="cart-item cart-column">
                      <span class="cart-item-title">{item.title}</span>
                    </div>
                    <span class="cart-price cart-column">
                      ${Number(prices[item.name]).toLocaleString()}
                    </span>
                    <div class="cart-quantity cart-column">
                      <input
                        class="cart-quantity-input"
                        type="number"
                        name={item.name}
                        value={quantities[item.name]}
                        onChange={onFormFieldChange}
                      />
                      <button
                        class="btn2 btn-danger"
                        type="button"
                        name={item.name}
                        onClick={removeCartItem}
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
          {shopItems.options.map((item, index) => (
            <div class="cart-items" key={item.title}>
              {quantities[item.name] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">{item.title}</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${Number(prices[item.name]).toLocaleString()}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name={item.name}
                      value={quantities[item.name]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name={item.name}
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}

          <div class="cart-total">
            <strong class="cart-total-title">Subtotal</strong>
            <span class="cart-total-price">
              ${cartTotal.preDiscountPrice.toLocaleString()}
            </span>
          </div>

          <div class="discount-button input-group mb-3">
            <input
              type="radio"
              class="btn-check"
              name="options"
              id="$"
              autocomplete="off"
              onClick={decideTypeDiscount}
            />
            <label class="btn btn-outline-primary" for="$">
              $
            </label>
            <input
              type="radio"
              class="btn-check"
              name="options"
              id="%"
              autocomplete="off"
              onClick={decideTypeDiscount}
            />
            <label class="btn btn-outline-primary" for="%">
              %
            </label>
            <input
              type="radio"
              class="btn-check"
              name="options"
              id="code"
              autocomplete="off"
              onClick={decideTypeDiscount}
            />
            <label class="btn btn-outline-primary" for="code">
              Code
            </label>
            <input
              type="text"
              style={{
                "margin-right": "10%",
                "padding-right": "5%",
                width: "16%",
              }}
              name="codeInput"
              onChange={onCouponFieldChanged}
              value={couponInput.codeInput}
            />
          </div>

          <div class="discount-button input-group mb-3 d-none">
            <button
              onClick={applyPromoCode}
              class="btn btn-outline-primary"
              for="Apply Coupon"
            >
              Apply Coupon
            </button>
            <input
              type="text"
              style={{
                "margin-right": "10%",
                "padding-right": "5%",
                width: "12%",
              }}
              name="promoCodeInput"
              onChange={onCouponFieldChanged}
              value={couponInput.promoCodeInput}
            />
          </div>
          {couponInput.dollarOff && (
            <>
              <div style={{ "margin-left": "77%" }}>
                <p className="">
                  {`Professional Discount Applied ($${couponInput.dollarOff}
                Off)`}{" "}
                </p>
              </div>
            </>
          )}

          {couponInput.pctOff && (
            <>
              <div style={{ "margin-left": "78%" }}>
                <p className="">
                  {`Professional Discount Applied ($${couponInput.displayDiscount}
                Off)`}{" "}
                </p>
              </div>
            </>
          )}
          {couponInput.depositAmount > 0 && (
            <>
              <div style={{ "margin-left": "78%", color: "red" }}>
                <p className="">
                  {`Deposit Applied ($${couponInput.depositAmount}
                Off)`}{" "}
                </p>
              </div>
            </>
          )}
          {/* {(couponInput.depositAmount || couponInput.pctOff || couponInput.dollarOff) && */}
          <div class="cart-total">
            <strong class="cart-total-title">Total</strong>
            <span class="cart-total-price">
              ${cartTotal.finalPrice.toLocaleString()}
            </span>
          </div>
          {/* } */}

          <div class="cart-row">
            <button
              class="btn2 btn-primary coupon-button"
              onClick={applyCoupon}
            >
              Apply Discount
            </button>
          </div>
        </section>
        <section className="container2 content-section">
          {(loading.loading &&isExistingBusiness.exists) && (
            <div className="cart-row">
               <h3>Checking lawmatics for company. This may take a while.</h3>
              <div style={{ "margin-top": "30px" }}>
                <Blocks
                  height="100"
                  width="100"
                  color="#4fa94d"
                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                  visible={true}
                />
              </div>
               
             
             
            </div>
          )}
          {isExistingBusiness.businessPurchase && (
            <select
              class="name-input cart-item cart-header cart-column email-input"
              //value={confirmInput.processorConfirm}
              name={"isExistingBusiness"}
              onChange={onConfirmFieldChanged2}
              style={{ "font-size": "15px" }}
              //</section> id={confirmInput.processorConfirmId}
            >
              <option selected>
                Is this for a company that is already formed and has an exisiting matter in Lawmatics?
              </option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          )}
          {(isExistingBusiness.hasBeenTouched ||
            isExistingBusiness.businessPurchase === false) && (
            <form onSubmit={confirmClicked}>
              <div>
                <label
                  class="cart-item cart-header cart-column"
                  for="clientEmail"
                >
                  Please Input Client's Email (Use Same Email in Lawmatics)
                </label>
                <input
                  required
                  class="name-input cart-item cart-header cart-column email-input"
                  type="email"
                  id="clientEmail"
                  value={couponInput.clientEmail}
                  name="clientEmail"
                  onChange={onCouponFieldChanged}
                />
                <button
                  class="btn2 btn-primary btn-purchase2"
                  id="confirmButton"
                  type="submit"
                  // onClick={confirmClicked}
                >
                  Confirm Client info
                </button>
              </div>
            </form>
          )}
          {confirmInput.searchedClient && (
            <form>
              <div className="cart-row">
                <label
                  class="cart-item cart-header cart-column"
                  for="clientConfirm"
                >
                  Confirm Client's Name
                </label>

                <label
                  class="cart-item cart-header cart-column ms-3"
                  for="processorConfirm"
                >
                  Confirm Legal Processor's Name
                </label>
              </div>
              <div className="cart-row">
                <input
                  class="name-input cart-item cart-header cart-column email-input"
                  type="text"
                  id=""
                  value={confirmInput.clientConfirm}
                  name="clientConfirm"
                  onChange={onConfirmFieldChanged}
                />
                <select
                  class="name-input cart-item cart-header cart-column email-input"
                  value={confirmInput.processorConfirm}
                  name={"processorConfirm"}
                  onChange={onConfirmFieldChanged}
                  style={{ "font-size": "15px" }}
                  id={confirmInput.processorConfirmId}
                >
                  <optgroup style={{ "font-size": "15px" }}>
                    {/* <option
                    key={"abc"}
                    value={"No Lead Attorney Found"}
                    name={"processorConfirm"}
                    onChange={onConfirmFieldChanged}
                  >
                    No Lead Attorney Found
                  </option> */}
                    {attorneys.map((attorney) => (
                      <option
                        key={attorney.id}
                        value={attorney.name}
                        name={"processorConfirm"}
                        onChange={onConfirmFieldChanged}
                        id={attorney.id}
                      >
                        {attorney.name}
                      </option>
                    ))}
                  </optgroup>
                </select>
              </div>
              <div className="cart-row">
                 <select
                    class="name-input cart-item cart-header cart-column email-input"
                    value={agentAttend}
                    name={"processorConfirm"}
                    onChange={onAgentAttendChanged}
                    style={{ "font-size": "15px" }}
                  >
                    {/* <optgroup style={{ "font-size": "15px" }}> */}
                      <option value={"Did Agent Attend Initial Consult?"} >Did Agent Attend Initial Consult?</option>
                                              <option
                          value={true}
                          name={"yes"}
                          onChange={onAgentAttendChanged}
                        >
                          Yes
                        </option>
                        <option
                          value={false}
                          name={"no"}
                          onChange={onAgentAttendChanged}
                        >
                          No
                        </option>
                    {/* </optgroup> */}
                  </select>
                  </div>
              <button
                // onClick={checkoutClicked}
                onClick={checkoutClicked}
                class="btn2 btn-primary btn-purchase3"
                type="button"
              >
                Checkout
              </button>
              {locationState.readyToCheckout &&
                locationState.confidoOrAffirm === "confidoPay" && (
                  <Navigate to="/checkout" state={locationState}></Navigate>
                )}
              {locationState.readyToCheckout &&
                locationState.confidoOrAffirm === "affirmPay" && (
                  <Navigate to="/lawpay" state={locationState}></Navigate>
                )}
              {/* <Link
                onClick={purchaseClicked}
                style={{ color: "white" }}
                state={locationState}
                to="/checkout"
                className={
                  confirmInput.clientConfirm && confirmInput.processorConfirmId !== " "
                    ? ""
                    : "disabledLink"
                }
              >
                 <button onClick={purchaseClicked} class="btn2 btn-primary btn-purchase3" type="button">Checkout</button>
                </Link> */}
            </form>
          )}
        </section>
      </div>
    </div>
  );
}

export default CustomCart;
